<template>
  <b-row>
    <b-col cols="12">
      <b-modal
        @shown="modalFinishedLoading"
        :visible="true"
        size="xl"
        :title="editData ? 'Modificar artículo' : 'Añadir artículo'"
        :ok-title="editData ? 'Modificar artículo' : 'Añadir artículo'"
        :ok-disabled="readOnly"
        :cancel-title="readOnly ? 'Cerrar' : 'Cancelar'"
        id="hover-modal"
        @ok="addProductModalBtn"
        @hidden="modalHidden"
      >
        <b-row v-if="productData">
          <b-col :cols="12">
            <b-row>
              <b-col :cols="8">
                <h4>{{ productData.reference }}</h4>
                <p>
                  Precio
                  {{
                    productData.is_price_variable
                      ? productData.costs.length > 0
                        ? 'variable (nuevo método)'
                        : 'variable: '
                      : 'fijo: ' + productData.price_incl_tax.toFixed(2)
                  }}
                  <span
                    v-if="
                      productData.is_price_variable &&
                      priceFormula &&
                      productData.costs.length === 0
                    "
                  >
                    {{ priceFormula.formula }}
                  </span>
                </p>
              </b-col>

              <b-col :cols="4">
                <b-form-group label="Unidades">
                  <b-form-input
                    type="text"
                    :disabled="readOnly"
                    :value="quantity.replace('.', ',')"
                    @change="setDecimal('quantity', $event)"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col :cols="12">
            <div class="mt-4" v-if="attributes.length > 0">
              <h5>Selectores</h5>

              <b-row>
                <b-col
                  class="mt-2"
                  :cols="3"
                  v-for="(v, i) in attributes"
                  :key="i"
                >
                  <CustomizerAttributeSelector
                    :ref="'customizer-' + i"
                    :label="v.label"
                    :type="v.reference"
                    :disabled="readOnly"
                    :selector_options="v.selector_options"
                    :extra_info="v.extra_info"
                    :initialValue="editData ? v.initial_value : null"
                    @optionSelected="optionSelected(v.reference, i, $event)"
                    @inputChanged="inputChanged(v.reference, i, $event)"
                  />
                </b-col>
              </b-row>
            </div>

            <b-row>
              <b-col :cols="productData.type === 'online' ? 6 : 12">
                <h5>Otros</h5>
                <b-row>
                  <b-form-group
                    label="Comentarios"
                    description="Aparecerán en la orden de taller"
                    class="col-12"
                  >
                    <b-form-textarea
                      rows="4"
                      :disabled="readOnly"
                      v-model="comments"
                    ></b-form-textarea>
                  </b-form-group> </b-row
              ></b-col>
              <b-col cols="12" v-if="productData.type === 'online'"
                ><h5>Vista previa</h5>
                <b-row
                  v-if="!three.initialized"
                  id="viewsDesktop"
                  class="mt-3 justify-content-md-between"
                  no-gutters
                  ><b-col
                    :class="[
                      'tab-' + i,
                      'text-center',
                      'col-12',
                      'col-md-' + 12 / views.length,
                    ]"
                    v-for="(v, i) in views"
                    :key="'tab-' + i"
                  >
                    <h5 class="text-center">{{ v.label }}</h5>
                    <canvas
                      :class="['canvas']"
                      :ref="'canvas-' + i"
                    ></canvas> </b-col
                ></b-row>

                <b-row v-else class="mt-3"
                  ><b-col
                    cols="6"
                    ref="viewsDesktop3D"
                    id="viewsDesktop3D"
                  ></b-col>
                </b-row>
              </b-col>
            </b-row>

            <h5 class="mt-4">
              Precio:
              {{ currentPrice.toFixed(2) }}
              €
            </h5>
          </b-col>
        </b-row>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import { fabric } from 'fabric';

import store from '@/admin/store.js';

import CustomizerAttributeSelector from '@/admin/components/customizer/CustomizerAttributeSelector.vue';

import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';

import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader.js';

export default {
  name: 'ProductModal',
  props: ['productID', 'editData', 'show', 'readOnly'],

  components: { CustomizerAttributeSelector },
  data() {
    return {
      interval: null,

      productData: null,
      priceFormula: null,
      attributes: [],
      sharedState: store.state,
      three: {
        initialized: false,
        scene: null,
        camera: null,
        renderer: null,
      },
      quantity: '1',
      comments: null,
      currentPrice: 0.0,

      // Customizer (preview)
      views: [],
      ratios: [],
      aspectRatio: null,
      stitch_size: null,
      currentRatio: null,
      minWidth: 0,
      canvas: [],
      canvasInitialized: false,
    };
  },
  created() {
    if (this.productID === null) {
    } else {
      // new
      actions.getProduct(this.productID).then((y) => {
        this.productData = y.data;

        if (this.productData.type === 'online') {
          /////
          //
          //  Online Product
          //
          /////
          actions.getProductTemplate(this.productData.template).then((x) => {
            let attributes = x.data.definition.attributes;

            for (let index = 0; index < attributes.length; index++) {
              const attName = attributes[index]['label'];
              attributes[index][
                'selector_id'
              ] = this.productData.textile_components.find(
                (xx) => xx.name === attName
              ).selector_id;
            }

            this.views = x.data.definition.views;

            this.ratios = x.data.definition.ratios;
            this.stitch_size = x.data.definition.stitch_size;
            this.aspectRatio =
              'aspectRatio' in x.data.definition
                ? x.data.definition.aspectRatio
                : null;

            let selectorsPromises = [];

            this.productData.textile_components
              .filter(
                (yy) =>
                  ![
                    'BORDADO',
                    'INICIALES',
                    'TAMANO_LIBRE',
                    'TAMANO_LIBRE_CAMA',
                  ].includes(yy.selector_type)
              )
              .map((yyy) => {
                selectorsPromises.push(
                  actions.getProductSelector(yyy.selector_id)
                );
              });

            Promise.all(selectorsPromises).then((yy) => {
              yy.map((xx) => {
                for (let index = 0; index < attributes.length; index++) {
                  const element = attributes[index];
                  const attributeType = element.reference;

                  /* We check not only that the attr type is the same (TELA === TELA)
                  but also the selector reference (SELECTOR_TELA_SABANAS === SELECTOR_TELA_SABANAS) */

                  if (
                    attributeType === xx.data.attribute &&
                    element.selector_id === xx.data.reference
                  ) {
                    attributes[index].selector_options = xx.data.options;
                    attributes[index].selector_inputs = {};
                    attributes[index].extra_info = {};
                  }
                }
              });

              this.setExtraInfoAttributes(attributes).then((yyy) => {
                this.attributes = yyy;
                // Set initial value if editing

                if (this.editData) {
                  // editing
                  for (let index = 0; index < this.attributes.length; index++) {
                    this.attributes[index].initial_value = this.editData
                      .attributes[index]
                      ? this.editData.attributes[index].selector_inputs
                      : null;
                  }

                  this.quantity = this.editData.quantity;
                  this.comments = this.editData.comments;
                }

                this.$nextTick(() => {
                  this.render();
                });
              });
            });
          });
        } else {
          /////
          //
          //  Offline Product
          //
          /////
          let attributes = [];
          this.productData.textile_components.map((x) => {
            attributes.push({
              label: x.name,
              reference: x.selector_type,
              selector_id: x.selector_id,
            });
          });
          let selectorsPromises = [];

          this.productData.textile_components
            .filter(
              (yy) =>
                ![
                  'BORDADO',
                  'INICIALES',
                  'TAMANO_LIBRE',
                  'TAMANO_LIBRE_CAMA',
                ].includes(yy.selector_type)
            )
            .map((yyy) => {
              selectorsPromises.push(
                actions.getProductSelector(yyy.selector_id)
              );
            });

          Promise.all(selectorsPromises).then((yy) => {
            yy.map((xx) => {
              for (let index = 0; index < attributes.length; index++) {
                const element = attributes[index];
                const attributeType = element.reference;

                if (
                  /* We check not only that the attr type is the same (TELA === TELA)
                  but also the selector reference (SELECTOR_TELA_SABANAS === SELECTOR_TELA_SABANAS) */
                  attributeType === xx.data.attribute &&
                  element.selector_id === xx.data.reference
                ) {
                  attributes[index].selector_options = xx.data.options;
                  attributes[index].selector_inputs = {};
                  attributes[index].extra_info = {};
                }
              }
            });

            this.setExtraInfoAttributes(attributes).then((yyy) => {
              this.attributes = yyy;
              // Add product attributes
              for (
                let index = 0;
                index < this.productData.attributes.length;
                index++
              ) {
                const element = this.productData.attributes[index];
                this.attributes.push({
                  label: element.name, //+
                  //(element.is_input ? ' (I_' + element.input + ')' : ''),
                  isPriceFormulaInput: element.is_input,
                  reference: 'INPUT',
                  input: element.input,
                  value: '',
                  selector_options: null,
                  selector_inputs: {},
                  extra_info: {},
                });
              }

              // Set initial value if editing

              if (this.editData) {
                // editing
                for (let index = 0; index < this.attributes.length; index++) {
                  this.attributes[index].initial_value = this.editData
                    .attributes[index]
                    ? this.editData.attributes[index].selector_inputs
                    : null;
                }

                this.quantity = this.editData.quantity;
                this.comments = this.editData.comments;
              }

              this.evaluateUpdatePriceAndCanvas();
            });
          });
        }

        if (this.productData.is_price_variable) {
          actions.getFormula(this.productData.formula).then((x) => {
            this.priceFormula = x.data;
          });
        } else {
          this.currentPrice = this.productData.price_incl_tax;
        }
      });
    }
  },
  beforeDestroy() {
    if (this.interval !== null) {
      clearTimeout(this.interval);
    }
  },
  methods: {
    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this[name] = val;
      this.evaluateUpdatePriceAndCanvas();
    },
    modalFinishedLoading() {
      let that = this;
      this.interval = setInterval(() => {
        if (that.$refs['viewsDesktop3D'] !== undefined) {
          that.render();
          clearInterval(that.interval);
        }
      }, 500);
    },
    loadSVGsEspecialMantel() {
      const enabled3DTablecloths = [
        'MANTEL_MUST',
        'MANTEL_ABSOLUTE',
        'MANTEL_DOBLE_BOR',
        'MANTEL_BOR',
        'MANTEL_ONDAS',
        'MANTEL_FLECOS_APL',
        'MANTEL_FLECOS',
      ].includes(this.productData.template);

      if (enabled3DTablecloths) {
        while (this.three.scene.children.length > 0) {
          this.three.scene.remove(this.three.scene.children[0]);
        }

        const isMantelMesaMust = this.productData.template === 'MANTEL_MUST';
        const isMantelMesaBordon = this.productData.template === 'MANTEL_BOR';
        const isMantelMesaDobleBordon =
          this.productData.template === 'MANTEL_DOBLE_BOR';
        const isMantelMesaAbsolute =
          this.productData.template === 'MANTEL_ABSOLUTE';
        const isMantelMesaOndas = this.productData.template === 'MANTEL_ONDAS';
        const isMantelMesaFlecosAplicado =
          this.productData.template === 'MANTEL_FLECOS_APL';
        const isMantelMesaFlecos =
          this.productData.template === 'MANTEL_FLECOS';

        let that = this;

        if (isMantelMesaMust) {
          const CAIDA = this.getValueForAttributeType('CAIDA').selector_inputs
            .value.fall;
          const TELA_CENTRO = this.getValueForAttributeTypeAndName(
            'TELA',
            'Tela'
          ).selector_inputs.value;

          const COLOR_HILO = this.getValueForAttributeType('HILO')
            .selector_inputs.value;

          const PUNTADA = this.getValueForAttributeType('PUNTADA')
            .selector_inputs.value;

          let url_first_part = null;
          let url_puntada = null;

          let promises = [];

          promises.push(this.getFabricInfo(TELA_CENTRO));
          promises.push(this.getColorInfo(COLOR_HILO));
          promises.push(this.getStitchInfo(PUNTADA));

          Promise.all(promises).then((x) => {
            const nameCAIDA = CAIDA;

            const hexCOLOR_HILO = x[1][0].code_hex;

            const PUNTADA_INFO = x[2];

            url_puntada = PUNTADA_INFO.image_white;

            url_first_part = x[0].image;

            const url_obj =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Must_fixed.glb`; //Must11

            const url_obj_patas =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Pata_v3.glb`;

            const url_wood =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/wood.png`;

            const svgLoader = new SVGLoader();

            var textureLoader = new THREE.TextureLoader();
            var map = textureLoader.load(url_first_part, function () {
              var map42 = textureLoader.load(url_wood, function () {
                var map80 = textureLoader.load(url_puntada, function () {
                  var material42 = new THREE.MeshPhongMaterial({ map: map42 });

                  const manager = new THREE.LoadingManager();

                  const loader = new GLTFLoader(manager);

                  loader.load(url_obj_patas, function (obj) {
                    obj.scene.traverse(function (node) {
                      if (node.isMesh && node.name === 'Leg') {
                        // Aplicar madera
                        node.material = material42;
                      }
                    });

                    that.three.scene.add(obj.scene);
                  });

                  loader.load(url_obj, function (obj) {
                    obj.scene.traverse(function (node) {
                      if (
                        node.isMesh &&
                        node.name === 'mantel_Must_+_patron001'
                      ) {
                        // Aplicar tela
                        const size = new THREE.Vector3();
                        const box = new THREE.Box3()
                          .setFromObject(node)
                          .getSize(size);

                        // Medido en Blender
                        const anchoMantel = 2.3 * 100; // OK
                        const largoMantel = 2.3 * 100; // OK

                        // box.z es el y
                        // box.x es el x

                        const anchoTelaMadre = x[0].base_width;
                        const largoTelaMadre = x[0].base_length;

                        const multiplier = 1;

                        const proporcionAncho =
                          (anchoMantel / anchoTelaMadre) * multiplier;
                        const proporcionLargo =
                          (largoMantel / largoTelaMadre) * multiplier;

                        map.rotation = THREE.Math.degToRad(-90);
                        map.wrapS = THREE.RepeatWrapping;
                        map.wrapT = THREE.RepeatWrapping;
                        map.repeat.set(proporcionLargo, proporcionAncho);
                        var material = new THREE.MeshPhongMaterial({
                          map: map,
                        });

                        node.material = material;
                      }
                    });

                    obj.scene.traverse(function (node) {
                      if (
                        node.isMesh &&
                        node.name === 'mantel_Must_+_patron002'
                      ) {
                        // Aplicar color línea

                        map80.wrapS = THREE.RepeatWrapping;

                        const multiplier = 0.7 * window.devicePixelRatio;

                        const largoMantel = 1.36 * 100; // 3.1 metros

                        const PX_IN_CM = 0.026458333;

                        const puntadaImageWidth =
                          map80.image.width *
                          window.devicePixelRatio *
                          PX_IN_CM;

                        const proporcionLargo =
                          (largoMantel / puntadaImageWidth) * multiplier;

                        map80.repeat.set(proporcionLargo, 1);
                        map80.flipY = false;

                        const materialColor = new THREE.MeshBasicMaterial({
                          color: new THREE.Color('#' + hexCOLOR_HILO),
                          map: map80,
                          side: THREE.FrontSide,
                          transparent: true,
                        });
                        node.material = materialColor;

                        node.geometry.computeVertexNormals(true);
                      }
                    });

                    that.three.scene.add(obj.scene);
                    that.three.camera.position.x = -2.5;
                    that.three.camera.position.y = 0.45;
                    that.three.camera.position.z = 0.7;
                    that.three.camera.lookAt(0, 0.45, 0.7);

                    const pointLight = new THREE.PointLight(0xffffff, 0.1);
                    pointLight.position.set(-7.8, 0.7, 1.8);
                    that.three.scene.add(pointLight);

                    const ambientLight = new THREE.AmbientLight(0xffffff, 0.9);
                    that.three.scene.add(ambientLight);

                    that.three.renderer.render(
                      that.three.scene,
                      that.three.camera
                    );
                  });
                });
              });
            });
          });
        } else if (isMantelMesaBordon) {
          const CAIDA = this.getValueForAttributeType('CAIDA').selector_inputs
            .value.fall;
          const TELA_CENTRO = this.getValueForAttributeTypeAndName(
            'TELA',
            'Tela'
          ).selector_inputs.value;

          const COLOR_HILO = this.getValueForAttributeType('HILO')
            .selector_inputs.value;

          let url_first_part = null;

          let promises = [];

          promises.push(this.getFabricInfo(TELA_CENTRO));
          promises.push(this.getColorInfo(COLOR_HILO));

          Promise.all(promises).then((x) => {
            const nameCAIDA = CAIDA;

            const hexCOLOR_HILO = x[1][0].code_hex;

            url_first_part = x[0].image;

            const url_obj =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Bordon_new.glb`;

            const url_obj_patas =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Pata_v3.glb`;

            const url_wood =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/wood.png`;

            var textureLoader = new THREE.TextureLoader();
            var map = textureLoader.load(url_first_part, function () {
              var map42 = textureLoader.load(url_wood, function () {
                var material42 = new THREE.MeshPhongMaterial({ map: map42 });

                const manager = new THREE.LoadingManager();

                const loader = new GLTFLoader(manager);

                loader.load(url_obj_patas, function (obj) {
                  obj.scene.traverse(function (node) {
                    if (node.isMesh && node.name === 'Leg') {
                      node.material = material42;
                    }
                  });

                  that.three.scene.add(obj.scene);
                });
                loader.load(url_obj, function (obj) {
                  obj.scene.traverse(function (node) {
                    if (node.isMesh && node.name === 'Mesh_1') {
                      // Aplicar tela
                      const size = new THREE.Vector3();
                      const box = new THREE.Box3()
                        .setFromObject(node)
                        .getSize(size);

                      // Medido en Blender
                      const anchoMantel = 2.3 * 100; // OK
                      const largoMantel = 2.3 * 100; // OK

                      const anchoTelaMadre = x[0].base_width;
                      const largoTelaMadre = x[0].base_length;

                      const multiplier = 1;

                      const proporcionAncho =
                        (anchoMantel / anchoTelaMadre) * multiplier;
                      const proporcionLargo =
                        (largoMantel / largoTelaMadre) * multiplier;

                      map.rotation = THREE.Math.degToRad(0);
                      map.wrapS = THREE.RepeatWrapping;
                      map.wrapT = THREE.RepeatWrapping;
                      map.repeat.set(proporcionLargo, proporcionAncho);
                      var material = new THREE.MeshPhongMaterial({ map: map });

                      node.material = material;
                    }

                    if (node.isMesh && node.name === 'Mesh') {
                      // Aplicar color línea
                      const materialColor = new THREE.MeshBasicMaterial({
                        color: new THREE.Color('#' + hexCOLOR_HILO),
                      });
                      node.material = materialColor;

                      node.geometry.computeVertexNormals(true);
                    }
                  });

                  that.three.scene.add(obj.scene);
                  that.three.camera.position.x = -2.5;
                  that.three.camera.position.y = 0.45;
                  that.three.camera.position.z = 0.7;
                  that.three.camera.lookAt(0, 0.45, 0.7);

                  const pointLight = new THREE.PointLight(0xffffff, 0.1);
                  pointLight.position.set(-7.8, 0.7, 1.8);
                  that.three.scene.add(pointLight);

                  const ambientLight = new THREE.AmbientLight(0xffffff, 0.9);
                  that.three.scene.add(ambientLight);

                  that.three.renderer.render(
                    that.three.scene,
                    that.three.camera
                  );
                });
              });
            });
          });
        } else if (isMantelMesaDobleBordon) {
          const CAIDA = this.getValueForAttributeType('CAIDA').selector_inputs
            .value.fall;
          const TELA_CENTRO = this.getValueForAttributeTypeAndName(
            'TELA',
            'Tela'
          ).selector_inputs.value;

          const COLOR_HILO = this.getValueForAttributeType('HILO')
            .selector_inputs.value;

          let url_first_part = null;

          let promises = [];

          promises.push(this.getFabricInfo(TELA_CENTRO));
          promises.push(this.getColorInfo(COLOR_HILO));

          Promise.all(promises).then((x) => {
            const nameCAIDA = CAIDA;

            const hexCOLOR_HILO = x[1][0].code_hex;

            url_first_part = x[0].image;

            const url_obj =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Doble_Bordon_2.glb`;

            const url_obj_patas =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Pata_v3.glb`;

            const url_wood =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/wood.png`;

            var textureLoader = new THREE.TextureLoader();
            var map = textureLoader.load(url_first_part, function () {
              var map42 = textureLoader.load(url_wood, function () {
                var material42 = new THREE.MeshPhongMaterial({ map: map42 });

                const manager = new THREE.LoadingManager();

                const loader = new GLTFLoader(manager);

                loader.load(url_obj_patas, function (obj) {
                  obj.scene.traverse(function (node) {
                    if (node.isMesh && node.name === 'Leg') {
                      node.material = material42;
                    }
                  });

                  that.three.scene.add(obj.scene);
                });
                loader.load(url_obj, function (obj) {
                  obj.scene.traverse(function (node) {
                    if (node.isMesh && node.name === 'Mesh001_1') {
                      // Aplicar tela
                      const size = new THREE.Vector3();
                      const box = new THREE.Box3()
                        .setFromObject(node)
                        .getSize(size);

                      // Medido en Blender
                      const anchoMantel = 2.3 * 100; // OK
                      const largoMantel = 2.3 * 100; // OK

                      const anchoTelaMadre = x[0].base_width;
                      const largoTelaMadre = x[0].base_length;

                      const multiplier = 1;

                      const proporcionAncho =
                        (anchoMantel / anchoTelaMadre) * multiplier;
                      const proporcionLargo =
                        (largoMantel / largoTelaMadre) * multiplier;

                      map.rotation = THREE.Math.degToRad(0);
                      map.wrapS = THREE.RepeatWrapping;
                      map.wrapT = THREE.RepeatWrapping;
                      map.repeat.set(proporcionLargo, proporcionAncho);
                      var material = new THREE.MeshPhongMaterial({ map: map });

                      node.material = material;
                    }

                    if (node.isMesh && node.name === 'Mesh001') {
                      // Aplicar color línea
                      const materialColor = new THREE.MeshBasicMaterial({
                        color: new THREE.Color('#' + hexCOLOR_HILO),
                      });
                      node.material = materialColor;

                      node.geometry.computeVertexNormals(true);
                    }
                  });

                  that.three.scene.add(obj.scene);
                  that.three.camera.position.x = -2.5;
                  that.three.camera.position.y = 0.45;
                  that.three.camera.position.z = 0.7;
                  that.three.camera.lookAt(0, 0.45, 0.7);

                  const pointLight = new THREE.PointLight(0xffffff, 0.1);
                  pointLight.position.set(-7.8, 0.7, 1.8);
                  that.three.scene.add(pointLight);

                  const ambientLight = new THREE.AmbientLight(0xffffff, 0.9);
                  that.three.scene.add(ambientLight);

                  that.three.renderer.render(
                    that.three.scene,
                    that.three.camera
                  );
                });
              });
            });
          });
        } else if (isMantelMesaAbsolute) {
          const CAIDA = this.getValueForAttributeType('CAIDA').selector_inputs
            .value.fall;
          const TELA_CENTRO = this.getValueForAttributeTypeAndName(
            'TELA',
            'Tela Centro'
          ).selector_inputs.value;

          const TELA_MARCO = this.getValueForAttributeTypeAndName(
            'TELA',
            'Tela Marco'
          ).selector_inputs.value;

          const COLOR_HILO = this.getValueForAttributeType('HILO')
            .selector_inputs.value;

          const PUNTADA = this.getValueForAttributeType('PUNTADA')
            .selector_inputs.value;

          let url_first_part = null;
          let url_second_part = null;
          let url_puntada = null;

          let promises = [];

          promises.push(this.getFabricInfo(TELA_CENTRO));
          promises.push(this.getFabricInfo(TELA_MARCO));

          promises.push(this.getColorInfo(COLOR_HILO));
          promises.push(this.getStitchInfo(PUNTADA));

          Promise.all(promises).then((x) => {
            const nameCAIDA = CAIDA;

            const hexCOLOR_HILO = x[2][0].code_hex;

            const PUNTADA_INFO = x[3];

            url_puntada = PUNTADA_INFO.image_white;

            url_first_part = x[0].image;
            url_second_part = x[1].image;

            const url_obj =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Abs_uv_motivo_fixed.glb`; //Must11

            const url_obj_patas =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Pata_v3.glb`;

            const url_wood =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/wood.png`;

            const svgLoader = new SVGLoader();

            var textureLoader = new THREE.TextureLoader();
            var map = textureLoader.load(url_first_part, function () {
              var map33 = textureLoader.load(url_second_part, function () {
                var map42 = textureLoader.load(url_wood, function () {
                  var map80 = textureLoader.load(url_puntada, function () {
                    var material42 = new THREE.MeshPhongMaterial({
                      map: map42,
                    });

                    // var material33 = new THREE.MeshPhongMaterial({
                    //   map: map33,
                    // });

                    const manager = new THREE.LoadingManager();

                    const loader = new GLTFLoader(manager);

                    loader.load(url_obj_patas, function (obj) {
                      obj.scene.traverse(function (node) {
                        if (node.isMesh && node.name === 'Leg') {
                          // Aplicar madera
                          node.material = material42;
                        }
                      });

                      that.three.scene.add(obj.scene);
                    });

                    loader.load(url_obj, function (obj) {
                      obj.scene.traverse(function (node) {
                        if (node.isMesh && node.name === 'Mesh003') {
                          // Aplicar tela

                          // Medido en Blender
                          const anchoMantel = 2.3 * 100; // OK
                          const largoMantel = 2.3 * 100; // OK

                          // box.z es el y
                          // box.x es el x

                          const anchoTelaMadre = x[0].base_width;
                          const largoTelaMadre = x[0].base_length;

                          const multiplier = 1;

                          const proporcionAncho =
                            (anchoMantel / anchoTelaMadre) * multiplier;
                          const proporcionLargo =
                            (largoMantel / largoTelaMadre) * multiplier;

                          map.rotation = THREE.Math.degToRad(-90);
                          map.wrapS = THREE.RepeatWrapping;
                          map.wrapT = THREE.RepeatWrapping;
                          map.repeat.set(proporcionLargo, proporcionAncho);
                          var material = new THREE.MeshPhongMaterial({
                            map: map,
                          });

                          node.material = material;
                        }

                        if (node.isMesh && node.name === 'Mesh003_1') {
                          // Aplicar tela

                          // Medido en Blender
                          const anchoMantel = 2.3 * 100; // OK
                          const largoMantel = 2.3 * 100; // OK

                          // box.z es el y
                          // box.x es el x

                          const anchoTelaMadre = x[1].base_width;
                          const largoTelaMadre = x[1].base_length;

                          const multiplier = 1;

                          const proporcionAncho =
                            (anchoMantel / anchoTelaMadre) * multiplier;
                          const proporcionLargo =
                            (largoMantel / largoTelaMadre) * multiplier;

                          map33.rotation = THREE.Math.degToRad(-90);
                          // tela marco
                          map33.wrapS = THREE.RepeatWrapping;
                          map33.wrapT = THREE.RepeatWrapping;
                          map33.repeat.set(proporcionLargo, proporcionAncho);
                          var material = new THREE.MeshPhongMaterial({
                            map: map33,
                          });

                          node.material = material;
                        }
                      });

                      obj.scene.traverse(function (node) {
                        if (
                          node.isMesh &&
                          node.name === 'mantel_Must_+_patron001'
                        ) {
                          // Aplicar color línea

                          map80.wrapS = THREE.RepeatWrapping;

                          const multiplier = 0.7 * window.devicePixelRatio;

                          const largoMantel = 1.36 * 100; // 3.1 metros

                          const PX_IN_CM = 0.026458333;

                          const puntadaImageWidth =
                            map80.image.width *
                            window.devicePixelRatio *
                            PX_IN_CM;

                          const proporcionLargo =
                            (largoMantel / puntadaImageWidth) * multiplier;

                          map80.repeat.set(proporcionLargo, 1);
                          map80.flipY = false;

                          const materialColor = new THREE.MeshBasicMaterial({
                            color: new THREE.Color('#' + hexCOLOR_HILO),
                            alphaMap: map80,
                            side: THREE.FrontSide,
                            transparent: true,
                          });
                          node.material = materialColor;

                          node.geometry.computeVertexNormals(true);
                        }
                      });

                      that.three.scene.add(obj.scene);
                      that.three.camera.position.x = -2.5;
                      that.three.camera.position.y = 0.45;
                      that.three.camera.position.z = 0.7;
                      that.three.camera.lookAt(0, 0.45, 0.7);

                      const pointLight = new THREE.PointLight(0xffffff, 0.1);
                      pointLight.position.set(-7.8, 0.7, 1.8);
                      that.three.scene.add(pointLight);

                      const ambientLight = new THREE.AmbientLight(
                        0xffffff,
                        0.9
                      );
                      that.three.scene.add(ambientLight);

                      that.three.renderer.render(
                        that.three.scene,
                        that.three.camera
                      );
                    });
                  });
                });
              });
            });
          });
        } else if (isMantelMesaOndas) {
          const CAIDA = this.getValueForAttributeType('CAIDA').selector_inputs
            .value.fall;
          const TELA_CENTRO = this.getValueForAttributeTypeAndName(
            'TELA',
            'Tela'
          ).selector_inputs.value;

          const COLOR_HILO = this.getValueForAttributeType('HILO')
            .selector_inputs.value;

          let url_first_part = null;

          let promises = [];

          promises.push(this.getFabricInfo(TELA_CENTRO));
          promises.push(this.getColorInfo(COLOR_HILO));

          Promise.all(promises).then((x) => {
            const nameCAIDA = CAIDA;

            const hexCOLOR_HILO = x[1][0].code_hex;

            url_first_part = x[0].image;

            const url_obj =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Ondas_v2.glb`;

            const url_obj_patas =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Pata_v3.glb`;

            const url_wood =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/wood.png`;

            var textureLoader = new THREE.TextureLoader();
            var map = textureLoader.load(url_first_part, function () {
              var map42 = textureLoader.load(url_wood, function () {
                var material42 = new THREE.MeshPhongMaterial({ map: map42 });

                const manager = new THREE.LoadingManager();

                const loader = new GLTFLoader(manager);

                loader.load(url_obj_patas, function (obj) {
                  obj.scene.traverse(function (node) {
                    if (node.isMesh && node.name === 'Leg') {
                      node.material = material42;
                    }
                  });

                  obj.scene.position.y += 0.03;
                  that.three.scene.add(obj.scene);
                });
                loader.load(url_obj, function (obj) {
                  obj.scene.traverse(function (node) {
                    if (node.isMesh && node.name === 'Mesh001') {
                      // Aplicar tela
                      const size = new THREE.Vector3();
                      const box = new THREE.Box3()
                        .setFromObject(node)
                        .getSize(size);

                      // Medido en Blender
                      const anchoMantel = 2.3 * 100; // OK
                      const largoMantel = 2.3 * 100; // OK

                      const anchoTelaMadre = x[0].base_width;
                      const largoTelaMadre = x[0].base_length;

                      const multiplier = 1;

                      const proporcionAncho =
                        (anchoMantel / anchoTelaMadre) * multiplier;
                      const proporcionLargo =
                        (largoMantel / largoTelaMadre) * multiplier;

                      map.rotation = THREE.Math.degToRad(90);
                      map.wrapS = THREE.RepeatWrapping;
                      map.wrapT = THREE.RepeatWrapping;
                      map.repeat.set(proporcionLargo, proporcionAncho);
                      var material = new THREE.MeshPhongMaterial({ map: map });

                      node.material = material;
                    }

                    if (node.isMesh && node.name === 'Mesh001_1') {
                      // Aplicar color línea
                      const materialColor = new THREE.MeshBasicMaterial({
                        color: new THREE.Color('#' + hexCOLOR_HILO),
                      });
                      node.material = materialColor;

                      node.geometry.computeVertexNormals(true);
                    }
                  });

                  that.three.scene.add(obj.scene);
                  that.three.camera.position.x = -2.5;
                  that.three.camera.position.y = 0.45;
                  that.three.camera.position.z = 0.7;
                  that.three.camera.lookAt(0, 0.45, 0.7);

                  const pointLight = new THREE.PointLight(0xffffff, 0.1);
                  pointLight.position.set(-7.8, 0.7, 1.8);
                  that.three.scene.add(pointLight);

                  const ambientLight = new THREE.AmbientLight(0xffffff, 0.9);
                  that.three.scene.add(ambientLight);

                  that.three.renderer.render(
                    that.three.scene,
                    that.three.camera
                  );
                });
              });
            });
          });
        } else if (isMantelMesaFlecosAplicado) {
          function traverseGroups(group) {
            let allObjects = [];
            group.traverse(function (object) {
              allObjects.push(object);
            });
            return allObjects;
          }

          // const CAIDA =
          //   this.getValueForAttributeType('CAIDA').selector_inputs.value.fall;

          const TELA_CENTRO = this.getValueForAttributeTypeAndName(
            'TELA',
            'Tela Mantel'
          ).selector_inputs.value;

          const TELA_APLIQUE = this.getValueForAttributeTypeAndName(
            'TELA',
            'Tela Aplique'
          ).selector_inputs.value;

          const COLOR_HILO = this.getValueForAttributeType('HILO')
            .selector_inputs.value;

          const PUNTADA = this.getValueForAttributeType('PUNTADA')
            .selector_inputs.value;

          // const COLOR_HILO =
          //   this.getValueForAttributeType('HILO').selector_inputs.value;

          let url_first_part,
            url_aplique,
            url_puntada = null;

          let promises = [];

          promises.push(this.getFabricInfo(TELA_CENTRO));
          promises.push(this.getFabricInfo(TELA_APLIQUE));

          promises.push(this.getColorInfo(COLOR_HILO));
          promises.push(this.getStitchInfo(PUNTADA));

          Promise.all(promises).then((x) => {
            url_first_part = x[0].image;
            url_aplique = x[1].image;

            const hexCOLOR_HILO = x[2][0].code_hex;
            const PUNTADA_INFO = x[3];

            url_puntada = PUNTADA_INFO.image_white;

            const url_obj =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Mantel_Flecos_Bueno.obj`;

            const url_alpha1 =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/flecos.jpg`;

            const url_alpha2 =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Flecos_aplicados_UV_invertido.jpg`;

            const url_flecosapl =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/flecos_aplicados.obj`;

            const url_obj2 =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/puntada_aplicados.obj`;

            const url_obj_patas =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Pata_v3.glb`;

            const url_wood =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/wood.png`;

            that.three.renderer.sortObjects = false;

            var textureLoader = new THREE.TextureLoader();

            var alphaMap = textureLoader.load(url_alpha1, function () {
              var alphaMap2 = textureLoader.load(url_alpha2, function () {
                var mapAplique = textureLoader.load(url_aplique, function () {
                  var map = textureLoader.load(url_first_part, function () {
                    var map80 = textureLoader.load(url_puntada, function () {
                      var map42 = textureLoader.load(url_wood, function () {
                        const manager = new THREE.LoadingManager();

                        const loader = new OBJLoader(manager);

                        const gltfLoader = new GLTFLoader(manager);

                        gltfLoader.load(url_obj_patas, function (obj) {
                          obj.scene.traverse(function (node) {
                            if (node.isMesh && node.name === 'Leg') {
                              // Aplicar madera

                              var material42 = new THREE.MeshPhongMaterial({
                                map: map42,
                              });

                              node.material = material42;

                              // obj.scene.position.x = 0.1;
                              // obj.scene.position.y = 0.1;
                              // obj.scene.position.z = 0.1;

                              obj.scene.position.set(0.125, 0, -0.1);
                              obj.scene.scale.set(0.3, 0.3, 0.3);
                              that.three.scene.add(obj.scene);
                            }
                          });
                        });

                        loader.load(url_obj, function (obj) {
                          const arr = traverseGroups(obj);
                          for (let index = 0; index < arr.length; index++) {
                            const node = arr[index];
                            console.log(node, node.name, node.isMesh);

                            if (node.name === '') {
                              // Aplicar tela

                              var material = new THREE.MeshPhongMaterial({
                                map: map,
                                alphaMap: alphaMap,
                                transparent: true,
                              });

                              node.material = material;

                              that.three.scene.add(obj);

                              // Aplicamos fleco aplicado

                              loader.load(
                                url_flecosapl,
                                function (objflecoapl) {
                                  const arr = traverseGroups(objflecoapl);
                                  for (
                                    let index = 0;
                                    index < arr.length;
                                    index++
                                  ) {
                                    const nodeflecapl = arr[index];
                                    console.log(
                                      'XXXX',
                                      nodeflecapl,
                                      nodeflecapl.name,
                                      nodeflecapl.isMesh
                                    );

                                    if (
                                      nodeflecapl.name === '' &&
                                      nodeflecapl.isMesh
                                    ) {
                                      // Aplicar tela

                                      var material = new THREE.MeshPhongMaterial(
                                        {
                                          map: mapAplique,
                                          alphaMap: alphaMap2,
                                          transparent: true,
                                        }
                                      );

                                      nodeflecapl.material = material;

                                      that.three.scene.add(objflecoapl);

                                      // Asegurar render de puntada dsps de tela y fleco aplicado
                                      loader.load(url_obj2, function (obj) {
                                        const arr = traverseGroups(obj);
                                        for (
                                          let index = 0;
                                          index < arr.length;
                                          index++
                                        ) {
                                          const node = arr[index];

                                          // Puntada
                                          if (node.isMesh && node.name === '') {
                                            map80.wrapS = THREE.RepeatWrapping;

                                            map80.repeat.set(14, 1);
                                            map80.flipY = false;

                                            const materialColor = new THREE.MeshBasicMaterial(
                                              {
                                                color: new THREE.Color(
                                                  '#' + hexCOLOR_HILO
                                                ),
                                                alphaMap: map80,
                                                side: THREE.FrontSide,
                                                transparent: true,
                                              }
                                            );

                                            node.material = materialColor;

                                            node.geometry.computeVertexNormals(
                                              true
                                            );

                                            that.three.scene.add(obj);
                                          }
                                        }
                                      });
                                    }
                                  }
                                }
                              );
                            }
                          }
                        });
                      });
                    });
                  });
                });
              });
            });

            that.three.camera.position.x = 0.025;
            that.three.camera.position.y = 0.15;
            that.three.camera.position.z = 0.5;
            that.three.camera.lookAt(0.025, 0.15, 0);

            const pointLight = new THREE.PointLight(0xffffff, 0.1);
            pointLight.position.set(-10, 5, -10);
            that.three.scene.add(pointLight);

            const ambientLight = new THREE.AmbientLight(0xffffff, 0.9);
            that.three.scene.add(ambientLight);

            that.three.renderer.render(that.three.scene, that.three.camera);
          });
        } else if (isMantelMesaFlecos) {
          function traverseGroups(group) {
            let allObjects = [];
            group.traverse(function (object) {
              allObjects.push(object);
            });
            return allObjects;
          }

          const CAIDA = this.getValueForAttributeType('CAIDA').selector_inputs
            .value.fall;
          const TELA_CENTRO = this.getValueForAttributeTypeAndName(
            'TELA',
            'Tela Mantel'
          ).selector_inputs.value;

          const COLOR_HILO = this.getValueForAttributeType('HILO')
            .selector_inputs.value;

          const PUNTADA = this.getValueForAttributeType('PUNTADA')
            .selector_inputs.value;

          // const COLOR_HILO =
          //   this.getValueForAttributeType('HILO').selector_inputs.value;

          let url_first_part,
            url_puntada = null;

          let promises = [];

          promises.push(this.getFabricInfo(TELA_CENTRO));

          promises.push(this.getColorInfo(COLOR_HILO));
          promises.push(this.getStitchInfo(PUNTADA));

          Promise.all(promises).then((x) => {
            url_first_part = x[0].image;

            const hexCOLOR_HILO = x[1][0].code_hex;
            const PUNTADA_INFO = x[2];

            url_puntada = PUNTADA_INFO.image_white;

            const url_obj =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Mantel_Flecos_Bueno.obj`;

            const url_alpha1 =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/flecos.jpg`;

            const url_obj2 =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/PUNTADA_FLECOS_CORREGIDA_UV.obj`;

            const url_obj_patas =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/Pata_v3.glb`;

            const url_wood =
              process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              '35' +
              `/wood.png`;

            // const url_alpha2 =
            //   process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            //   'uploads/product_templates/' +
            //   this.productData.template +
            //   '/' +
            //   '35' +
            //   `/flecos_puntada.jpg`;

            // const url_alpha2=
            // process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            // 'uploads/product_templates/' +
            // this.productData.template +
            // '/' +
            // '35' +
            // `/alpha_mantel.png.png`;

            // const axesHelper = new THREE.AxesHelper(15);

            // that.three.scene.add(axesHelper);
            that.three.renderer.sortObjects = false;

            var textureLoader = new THREE.TextureLoader();

            var alphaMap = textureLoader.load(url_alpha1, function () {
              var map = textureLoader.load(url_first_part, function () {
                var map80 = textureLoader.load(url_puntada, function () {
                  var map42 = textureLoader.load(url_wood, function () {
                    const manager = new THREE.LoadingManager();

                    const loader = new OBJLoader(manager);

                    const gltfLoader = new GLTFLoader(manager);

                    gltfLoader.load(url_obj_patas, function (obj) {
                      obj.scene.traverse(function (node) {
                        if (node.isMesh && node.name === 'Leg') {
                          // Aplicar madera

                          var material42 = new THREE.MeshPhongMaterial({
                            map: map42,
                          });

                          node.material = material42;

                          // obj.scene.position.x = 0.1;
                          // obj.scene.position.y = 0.1;
                          // obj.scene.position.z = 0.1;

                          obj.scene.position.set(0.125, 0, -0.1);
                          obj.scene.scale.set(0.3, 0.3, 0.3);
                          that.three.scene.add(obj.scene);
                        }
                      });
                    });

                    loader.load(url_obj, function (obj) {
                      const arr = traverseGroups(obj);
                      for (let index = 0; index < arr.length; index++) {
                        const node = arr[index];
                        console.log(node, node.name, node.isMesh);

                        if (node.name === '') {
                          // Aplicar tela

                          var material = new THREE.MeshPhongMaterial({
                            map: map,
                            alphaMap: alphaMap,
                            transparent: true,
                          });

                          node.material = material;

                          that.three.scene.add(obj);

                          // Asegurar render de puntada dsps de tela
                          loader.load(url_obj2, function (obj) {
                            const arr = traverseGroups(obj);
                            for (let index = 0; index < arr.length; index++) {
                              const node = arr[index];
                              console.log(
                                'PUNTADA?',
                                node,
                                node.name,
                                node.isMesh
                              );

                              // Puntada
                              if (node.isMesh && node.name === '') {
                                map80.wrapS = THREE.RepeatWrapping;

                                map80.repeat.set(14, 1);
                                map80.flipY = false;

                                const materialColor = new THREE.MeshBasicMaterial(
                                  {
                                    color: new THREE.Color('#' + hexCOLOR_HILO),
                                    alphaMap: map80,
                                    side: THREE.FrontSide,
                                    transparent: true,
                                  }
                                );

                                node.material = materialColor;

                                node.geometry.computeVertexNormals(true);

                                that.three.scene.add(obj);
                              }
                            }
                          });
                        }
                      }
                    });
                  });
                });
              });
            });

            that.three.camera.position.x = 0.025;
            that.three.camera.position.y = 0.15;
            that.three.camera.position.z = 0.5;
            that.three.camera.lookAt(0.025, 0.15, 0);

            const pointLight = new THREE.PointLight(0xffffff, 0.1);
            pointLight.position.set(-10, 5, -10);
            that.three.scene.add(pointLight);

            const ambientLight = new THREE.AmbientLight(0xffffff, 0.9);
            that.three.scene.add(ambientLight);

            that.three.renderer.render(that.three.scene, that.three.camera);
          });
        }
      }
    },
    loadSVGsEspecialFlecosMixed() {
      let that = this;
      this.canvas[0].remove(
        ...this.canvas[0].getObjects().filter((item) => {
          if (item.type !== 'group') {
            let elementID = item.id || '';
            if (
              elementID === 'imgpuntada' ||
              elementID === 'imgfleco' ||
              elementID === 'imgtelafleco' ||
              elementID === 'imgflecoaplique'
            ) {
              return true;
            }
            return false;
          }
        })
      );

      const productWithOneSideOnly = [
        'SERV_MESA_FLECOS',
        'SERV_MERI_FLECOS',
        'SERV_COCKT_FLECOS',
        'SERV_MESA_FLEC_APL',
        'CAM_MES_FLEC',
        'CAM_MES_FLEC_APL',
        'CAM_MES_MUST',
      ].includes(this.productData.template);

      if (!productWithOneSideOnly) {
        this.canvas[1].remove(
          ...this.canvas[1].getObjects().filter((item) => {
            if (item.type !== 'group') {
              let elementID = item.id || '';
              if (
                elementID === 'imgpuntada' ||
                elementID === 'imgfleco' ||
                elementID === 'imgtelafleco'
              ) {
                return true;
              }
              return false;
            }
          })
        );
      }

      const isIndividualFlecoAplicadoRedondo =
        this.productData.template === 'IND_FLECO_APL_RED';

      const isIndividualFlecosRedondo =
        this.productData.template === 'IND_FLECO_RED';

      const isIndividualFlecos = this.productData.template === 'IND_FLECOS';

      const isCaminoMesaFlecos = this.productData.template === 'CAM_MES_FLEC';

      const isCaminoMesaMust = this.productData.template === 'CAM_MES_MUST';

      const isCaminoMesaFlecosAplicado =
        this.productData.template === 'CAM_MES_FLEC_APL';

      const isIndividualFlecosAplicado =
        this.productData.template === 'IND_FLECOS_APLICADO';

      const isServilletaMesaFlecos =
        this.productData.template === 'SERV_MESA_FLECOS';

      const isServilletaMesaFlecosAplicado =
        this.productData.template === 'SERV_MESA_FLEC_APL';

      const isServilletaMeriendaFlecos =
        this.productData.template === 'SERV_MERI_FLECOS';

      const isServilletaCocktailFlecos =
        this.productData.template === 'SERV_COCKT_FLECOS';

      if (isIndividualFlecosRedondo) {
        const COLOR_HILO = this.getValueForAttributeType('HILO').selector_inputs
          .value;

        const PUNTADA = this.getValueForAttributeType('PUNTADA').selector_inputs
          .value;

        let url_puntada = null;
        let url_flecos = null;

        let promises = [];

        promises.push(this.getColorInfo(COLOR_HILO));
        promises.push(this.getStitchInfo(PUNTADA));

        Promise.all(promises).then((x) => {
          // const nameTAMANO = this.getValueForAttributeType(
          //   'TAMANO_DIAM'
          // ).selector_inputs.name.toUpperCase();

          const hexCOLOR_HILO = x[0][0].code_hex;
          const namePUNTADA = x[1].reference
            .toUpperCase()
            .replaceAll(' ', '_')
            .replaceAll('Ó', 'O');

          url_flecos =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS/' +
            `ESTANDAR2.png`;

          url_puntada =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            `/PUNTADAS/` +
            `${namePUNTADA}_REDONDO_BLACK.png`;

          // Error - image does not exist. Render and add fleco and puntada.
          let viewsByID = {
            A: 0,
            B: 1,
          };

          // Show SVG group
          that.canvas[0].getObjects().map((y) => {
            if (y.type === 'group') {
              y.opacity = 1;
            }
          });

          that.renderTELA(that.attributes[1], viewsByID);

          fabric.Image.fromURL(
            url_flecos,
            function (imgFlecoA) {
              imgFlecoA.set({ id: 'imgfleco' });

              imgFlecoA.set({ left: 0, top: 0 });

              imgFlecoA.scaleToWidth(that.canvas[0].getWidth());

              that.canvas[0].add(imgFlecoA);
              that.canvas[0].bringToFront(imgFlecoA);

              fabric.Image.fromURL(
                url_puntada,
                function (imgPuntada) {
                  imgPuntada.set({ id: 'imgpuntada' });
                  const filter = new fabric.Image.filters.BlendColor({
                    color: '#' + hexCOLOR_HILO,
                    mode: 'tint',
                  });

                  let oImgPuntada = imgPuntada.set({ left: 0, top: 0 });

                  oImgPuntada.filters.push(filter);

                  oImgPuntada.scaleToWidth(that.canvas[0].getWidth());

                  oImgPuntada.applyFilters();

                  that.canvas[0].add(oImgPuntada);
                  that.canvas[0].bringToFront(oImgPuntada);

                  that.canvas[0].renderAll();
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );

          // Show SVG group
          that.canvas[1].getObjects().map((y) => {
            if (y.type === 'group') {
              y.opacity = 1;
            }
          });

          that.renderTELA(that.attributes[2], viewsByID);

          fabric.Image.fromURL(
            url_flecos,
            function (imgFlecoB) {
              imgFlecoB.set({ id: 'imgfleco' });

              imgFlecoB.set({ left: 0, top: 0 });

              imgFlecoB.scaleToWidth(that.canvas[1].getWidth());

              that.canvas[1].add(imgFlecoB);
              that.canvas[1].bringToFront(imgFlecoB);

              fabric.Image.fromURL(
                url_puntada,
                function (imgPuntada) {
                  imgPuntada.set({ id: 'imgpuntada' });
                  const filter = new fabric.Image.filters.BlendColor({
                    color: '#' + hexCOLOR_HILO,
                    mode: 'tint',
                  });

                  let oImgPuntada = imgPuntada.set({ left: 0, top: 0 });

                  oImgPuntada.filters.push(filter);

                  oImgPuntada.scaleToWidth(that.canvas[1].getWidth());

                  oImgPuntada.applyFilters();

                  that.canvas[1].add(oImgPuntada);
                  that.canvas[1].bringToFront(oImgPuntada);

                  that.canvas[1].renderAll();
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );
        });
      } else if (isIndividualFlecoAplicadoRedondo) {
        const COLOR_HILO = this.getValueForAttributeType('HILO').selector_inputs
          .value;

        const PUNTADA = this.getValueForAttributeType('PUNTADA').selector_inputs
          .value;

        const TELA_A = this.getValueForAttributeTypeAndName(
          'TELA',
          'Tela Cara A'
        ).selector_inputs.value;

        const TELA_B = this.getValueForAttributeTypeAndName(
          'TELA',
          'Tela Cara B'
        ).selector_inputs.value;

        const APLIQUE = this.getValueForAttributeTypeAndName(
          'TELA',
          'Aplique (Cara A)'
        ).selector_inputs.value;

        let url_puntada = null;
        let url_flecos_tela = null;
        let url_tela_fleco_A = null;
        let url_tela_fleco_B = null;
        let url_flecos_aplique = null;

        let promises = [];

        promises.push(this.getColorInfo(COLOR_HILO));
        promises.push(this.getStitchInfo(PUNTADA));
        promises.push(this.getFabricInfo(APLIQUE));

        Promise.all(promises).then((x) => {
          // const nameTAMANO = this.getValueForAttributeType(
          //   'TAMANO_DIAM'
          // ).selector_inputs.name.toUpperCase();

          const hexCOLOR_HILO = x[0][0].code_hex;
          const namePUNTADA = x[1].reference
            .toUpperCase()
            .replaceAll(' ', '_')
            .replaceAll('Ó', 'O');

          const TELA_APLIQUE_INFO = x[2];

          let colorApliqueHex = '#ebebeb';

          if (TELA_APLIQUE_INFO['primary_color_code_hex']) {
            colorApliqueHex = TELA_APLIQUE_INFO['primary_color_code_hex'];
          }

          url_flecos_tela =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS/' +
            `ESTANDAR2.png`;

          url_flecos_aplique =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS_APLIQUE/' +
            `ESTANDAR.png`;

          url_puntada =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            `/PUNTADAS/` +
            `${namePUNTADA}_REDONDO_BLACK.png`;

          // View A FLECO APLICADO REDONDO

          // Error - image does not exist. Render and add fleco and puntada.
          let viewsByID = {
            A: 0,
            B: 1,
          };

          // Show SVG group
          that.canvas[0].getObjects('group').map((y) => {
            y.opacity = 1;

            y.getObjects().map((zz) => {
              zz.opacity = 1;
            });
          });

          that.renderTELA(that.attributes[1], viewsByID);
          that.renderTELA(that.attributes[3], viewsByID);

          fabric.Image.fromURL(
            url_flecos_tela,
            function (imgFlecoA) {
              imgFlecoA.set({ id: 'imgfleco' });

              imgFlecoA.set({ left: 0, top: 0 });

              imgFlecoA.scaleToWidth(that.canvas[0].getWidth());

              that.canvas[0].add(imgFlecoA);
              that.canvas[0].bringToFront(imgFlecoA);

              fabric.Image.fromURL(
                url_flecos_aplique,
                function (imgFlecosAplique) {
                  imgFlecosAplique.set({ id: 'imgflecoaplique' });

                  const filterFlecoAplique = new fabric.Image.filters.BlendColor(
                    {
                      color: colorApliqueHex,
                      mode: 'tint',
                    }
                  );

                  imgFlecosAplique.set({ left: 0, top: 0 });

                  imgFlecosAplique.filters.push(filterFlecoAplique);

                  imgFlecosAplique.applyFilters();

                  imgFlecosAplique.scaleToWidth(that.canvas[0].getWidth());

                  that.canvas[0].add(imgFlecosAplique);
                  that.canvas[0].bringToFront(imgFlecosAplique);

                  fabric.Image.fromURL(
                    url_puntada,
                    function (imgPuntada) {
                      imgPuntada.set({ id: 'imgpuntada' });
                      const filter = new fabric.Image.filters.BlendColor({
                        color: '#' + hexCOLOR_HILO,
                        mode: 'tint',
                      });

                      let oImgPuntada = imgPuntada.set({
                        left: 0,
                        top: 0,
                      });

                      oImgPuntada.filters.push(filter);

                      oImgPuntada.scaleToWidth(that.canvas[0].getWidth());

                      oImgPuntada.applyFilters();

                      that.canvas[0].add(oImgPuntada);
                      that.canvas[0].bringToFront(oImgPuntada);

                      that.canvas[0].renderAll();
                    },
                    { crossOrigin: 'Anonymous' }
                  );
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );

          // View B FLECO APLICADO REDONDO

          // Show SVG group
          that.canvas[1].getObjects('group').map((y) => {
            y.opacity = 1;
          });

          that.renderTELA(that.attributes[2], viewsByID);

          fabric.Image.fromURL(
            url_flecos_tela,
            function (imgFlecoB) {
              imgFlecoB.set({ id: 'imgfleco' });

              imgFlecoB.set({ left: 0, top: 0 });

              imgFlecoB.scaleToWidth(that.canvas[1].getWidth());

              that.canvas[1].add(imgFlecoB);
              that.canvas[1].bringToFront(imgFlecoB);

              fabric.Image.fromURL(
                url_puntada,
                function (imgPuntada) {
                  imgPuntada.set({ id: 'imgpuntada' });
                  const filter = new fabric.Image.filters.BlendColor({
                    color: '#' + hexCOLOR_HILO,
                    mode: 'tint',
                  });

                  let oImgPuntada = imgPuntada.set({
                    left: 0,
                    top: 0,
                  });

                  oImgPuntada.filters.push(filter);

                  oImgPuntada.scaleToWidth(that.canvas[1].getWidth());

                  oImgPuntada.applyFilters();

                  that.canvas[1].add(oImgPuntada);
                  that.canvas[1].bringToFront(oImgPuntada);

                  that.canvas[1].renderAll();
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );
        });
      } else if (isIndividualFlecos) {
        const COLOR_HILO = this.getValueForAttributeType('HILO').selector_inputs
          .value;

        const PUNTADA = this.getValueForAttributeType('PUNTADA').selector_inputs
          .value;

        const TELA_A = this.getValueForAttributeTypeAndName(
          'TELA',
          'Tela Cara A'
        ).selector_inputs.value;

        const TELA_B = this.getValueForAttributeTypeAndName(
          'TELA',
          'Tela Cara B'
        ).selector_inputs.value;

        let url_puntada = null;
        let url_flecos_A = null;
        let url_flecos_B = null;

        let promises = [];

        promises.push(this.getColorInfo(COLOR_HILO));
        promises.push(this.getStitchInfo(PUNTADA));
        promises.push(this.getFabricInfo(TELA_A));
        promises.push(this.getFabricInfo(TELA_B));

        Promise.all(promises).then((x) => {
          // const nameTAMANO = this.getValueForAttributeType(
          //   'TAMANO_DIAM'
          // ).selector_inputs.name.toUpperCase();

          const hexCOLOR_HILO = x[0][0].code_hex;
          const namePUNTADA = x[1].reference
            .toUpperCase()
            .replaceAll(' ', '_')
            .replaceAll('Ó', 'O');

          const TELA_A_INFO = x[2];
          const TELA_B_INFO = x[3];

          // if (TELA_A_INFO['primary_color_code_hex']) {
          //   colorTelaAHex = TELA_A_INFO['primary_color_code_hex'];
          // }
          // if (TELA_B_INFO['primary_color_code_hex']) {
          //   colorTelaBHex = TELA_B_INFO['primary_color_code_hex'];
          // }

          let flecoTypeTelaA =
            TELA_A_INFO['extra_type'] === 'FLECOS_IND_LAT_BLANCOS'
              ? 'ESTANDAR2_LAT_WHITE.png'
              : 'ESTANDAR2_FULL.png';
          let flecoTypeTelaB =
            TELA_B_INFO['extra_type'] === 'FLECOS_IND_LAT_BLANCOS'
              ? 'ESTANDAR2_LAT_WHITE.png'
              : 'ESTANDAR2_FULL.png';

          /// Si la tela está en formato imagen, mostramos esa -sólo estará disponible para telas complicadas-

          ///////////////

          url_flecos_A =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS/' +
            flecoTypeTelaA;

          url_flecos_B =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS/' +
            flecoTypeTelaB;

          url_puntada =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            `/PUNTADAS/` +
            `FLECO_INDIVIDUAL_${namePUNTADA}_BLACK.png`;

          // View A INDIVIDUAL FLECOS

          // Error - image does not exist. Render and add fleco and puntada.
          let viewsByID = {
            A: 0,
            B: 1,
          };

          // Show SVG group
          that.canvas[0].getObjects().map((y) => {
            if (y.type === 'group') {
              y.opacity = 1;
            }
          });

          that.renderTELA(that.attributes[1], viewsByID);

          fabric.Image.fromURL(
            url_flecos_A,
            function (imgFlecoA) {
              imgFlecoA.set({ id: 'imgfleco' });

              imgFlecoA.set({ left: 0, top: 0 });

              imgFlecoA.scaleToWidth(that.canvas[0].getWidth());

              that.canvas[0].add(imgFlecoA);
              that.canvas[0].bringToFront(imgFlecoA);

              fabric.Image.fromURL(
                url_puntada,
                function (imgPuntada) {
                  imgPuntada.set({ id: 'imgpuntada' });
                  const filter = new fabric.Image.filters.BlendColor({
                    color: '#' + hexCOLOR_HILO,
                    mode: 'tint',
                  });

                  let oImgPuntada = imgPuntada.set({ left: 0, top: 0 });

                  oImgPuntada.filters.push(filter);

                  oImgPuntada.scaleToWidth(that.canvas[0].getWidth());

                  oImgPuntada.applyFilters();

                  that.canvas[0].add(oImgPuntada);
                  that.canvas[0].bringToFront(oImgPuntada);

                  that.canvas[0].renderAll();
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );

          // View B INDIVIDUAL FLECOS

          // Error - image does not exist. Render and add fleco and puntada.

          // Show SVG group
          that.canvas[1].getObjects().map((y) => {
            if (y.type === 'group') {
              y.opacity = 1;
            }
          });

          that.renderTELA(that.attributes[2], viewsByID);

          fabric.Image.fromURL(
            url_flecos_B,
            function (imgFlecoB) {
              imgFlecoB.set({ id: 'imgfleco' });

              imgFlecoB.set({ left: 0, top: 0 });

              imgFlecoB.scaleToWidth(that.canvas[1].getWidth());

              that.canvas[1].add(imgFlecoB);
              that.canvas[1].bringToFront(imgFlecoB);

              fabric.Image.fromURL(
                url_puntada,
                function (imgPuntada) {
                  imgPuntada.set({ id: 'imgpuntada' });
                  const filter = new fabric.Image.filters.BlendColor({
                    color: '#' + hexCOLOR_HILO,
                    mode: 'tint',
                  });

                  let oImgPuntada = imgPuntada.set({ left: 0, top: 0 });

                  oImgPuntada.filters.push(filter);

                  oImgPuntada.scaleToWidth(that.canvas[1].getWidth());

                  oImgPuntada.applyFilters();

                  that.canvas[1].add(oImgPuntada);
                  that.canvas[1].bringToFront(oImgPuntada);

                  that.canvas[1].renderAll();
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );
        });
      } else if (isIndividualFlecosAplicado) {
        const COLOR_HILO = this.getValueForAttributeType('HILO').selector_inputs
          .value;

        const PUNTADA = this.getValueForAttributeType('PUNTADA').selector_inputs
          .value;

        const TELA_A = this.getValueForAttributeTypeAndName(
          'TELA',
          'Tela Cara A'
        ).selector_inputs.value;

        const TELA_B = this.getValueForAttributeTypeAndName(
          'TELA',
          'Tela Cara B'
        ).selector_inputs.value;

        const APLIQUE = this.getValueForAttributeTypeAndName('TELA', 'Aplique')
          .selector_inputs.value;

        let url_puntada = null;
        let url_flecos_tela = null;
        let url_tela_fleco_A = null;
        let url_tela_fleco_B = null;
        let url_flecos_aplique = null;
        let url_flecos_A = null;
        let url_flecos_B = null;

        let promises = [];

        promises.push(this.getColorInfo(COLOR_HILO));
        promises.push(this.getStitchInfo(PUNTADA));
        promises.push(this.getFabricInfo(TELA_A));
        promises.push(this.getFabricInfo(TELA_B));
        promises.push(this.getFabricInfo(APLIQUE));

        Promise.all(promises).then((x) => {
          // const nameTAMANO = this.getValueForAttributeType(
          //   'TAMANO_DIAM'
          // ).selector_inputs.name.toUpperCase();

          const hexCOLOR_HILO = x[0][0].code_hex;
          const namePUNTADA = x[1].reference
            .toUpperCase()
            .replaceAll(' ', '_')
            .replaceAll('Ó', 'O');

          const TELA_A_INFO = x[2];
          const TELA_B_INFO = x[3];
          const TELA_APLIQUE_INFO = x[4];

          let colorTelaAHex = '#ebebeb';
          let colorTelaBHex = '#ebebeb';
          let colorApliqueHex = '#ebebeb';

          if (TELA_A_INFO['primary_color_code_hex']) {
            colorTelaAHex = TELA_A_INFO['primary_color_code_hex'];
          }
          if (TELA_B_INFO['primary_color_code_hex']) {
            colorTelaBHex = TELA_B_INFO['primary_color_code_hex'];
          }
          if (TELA_APLIQUE_INFO['primary_color_code_hex']) {
            colorApliqueHex = TELA_APLIQUE_INFO['primary_color_code_hex'];
          }

          let flecoTypeTelaA =
            TELA_A_INFO['extra_type'] === 'FLECOS_IND_LAT_BLANCOS'
              ? 'ESTANDAR2_LAT_WHITE2.png'
              : 'ESTANDAR2_FULL2.png';

          let flecoTypeTelaB =
            TELA_B_INFO['extra_type'] === 'FLECOS_IND_LAT_BLANCOS'
              ? 'ESTANDAR2_LAT_WHITE2.png'
              : 'ESTANDAR2_FULL2.png';

          /// Si la tela está en formato imagen, mostramos esa -sólo estará disponible para telas complicadas-

          ///////////////

          const NAME_TELA_A = x[2].reference.toUpperCase().replaceAll(' ', '_');
          const NAME_TELA_B = x[3].reference.toUpperCase().replaceAll(' ', '_');

          url_tela_fleco_A =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS_TELAS/' +
            `${NAME_TELA_A}/OUT_40X50.png`;

          url_tela_fleco_B =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS_TELAS/' +
            `${NAME_TELA_B}/OUT_40X50.png`;

          url_flecos_A =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS/' +
            flecoTypeTelaA;

          url_flecos_B =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS/' +
            flecoTypeTelaB;

          url_flecos_aplique =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS_APLIQUE/' +
            `ESTANDAR.png`;

          url_puntada =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            `/PUNTADAS/` +
            `FLECO_INDIVIDUAL_${namePUNTADA}_BLACK.png`;

          // Error - image does not exist. Render and add fleco and puntada.
          let viewsByID = {
            A: 0,
            B: 1,
          };

          // Show SVG group
          that.canvas[0].getObjects('group').map((y) => {
            y.opacity = 1;

            y.getObjects().map((zz) => {
              zz.opacity = 1;
            });
          });

          that.renderTELA(that.attributes[1], viewsByID);
          that.renderTELA(that.attributes[3], viewsByID);

          fabric.Image.fromURL(
            url_flecos_A,
            function (imgFlecoA) {
              imgFlecoA.set({ id: 'imgfleco' });

              imgFlecoA.set({ left: 0, top: 0 });

              imgFlecoA.scaleToWidth(that.canvas[0].getWidth());

              that.canvas[0].add(imgFlecoA);
              that.canvas[0].bringToFront(imgFlecoA);

              fabric.Image.fromURL(
                url_flecos_aplique,
                function (imgFlecosAplique) {
                  imgFlecosAplique.set({ id: 'imgflecoaplique' });

                  const filterFlecoAplique = new fabric.Image.filters.BlendColor(
                    {
                      color: colorApliqueHex,
                      mode: 'tint',
                    }
                  );

                  imgFlecosAplique.set({ left: 0, top: 0 });

                  imgFlecosAplique.filters.push(filterFlecoAplique);

                  imgFlecosAplique.applyFilters();

                  imgFlecosAplique.scaleToWidth(that.canvas[0].getWidth());

                  that.canvas[0].add(imgFlecosAplique);
                  that.canvas[0].bringToFront(imgFlecosAplique);

                  fabric.Image.fromURL(
                    url_puntada,
                    function (imgPuntada) {
                      imgPuntada.set({ id: 'imgpuntada' });
                      const filter = new fabric.Image.filters.BlendColor({
                        color: '#' + hexCOLOR_HILO,
                        mode: 'tint',
                      });

                      let oImgPuntada = imgPuntada.set({
                        left: 0,
                        top: 0,
                      });

                      oImgPuntada.filters.push(filter);

                      oImgPuntada.scaleToWidth(that.canvas[0].getWidth());

                      oImgPuntada.applyFilters();

                      that.canvas[0].add(oImgPuntada);
                      that.canvas[0].bringToFront(oImgPuntada);

                      that.canvas[0].renderAll();
                    },
                    { crossOrigin: 'Anonymous' }
                  );
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );

          // View B INDIVIDUAL FLECO APLICADO

          // Show SVG group
          that.canvas[1].getObjects('group').map((y) => {
            y.opacity = 1;
          });

          that.renderTELA(that.attributes[2], viewsByID);

          fabric.Image.fromURL(
            url_flecos_B,
            function (imgFlecoB) {
              imgFlecoB.set({ id: 'imgfleco' });

              imgFlecoB.set({ left: 0, top: 0 });

              imgFlecoB.scaleToWidth(that.canvas[1].getWidth());

              that.canvas[1].add(imgFlecoB);
              that.canvas[1].bringToFront(imgFlecoB);

              fabric.Image.fromURL(
                url_puntada,
                function (imgPuntada) {
                  imgPuntada.set({ id: 'imgpuntada' });
                  const filter = new fabric.Image.filters.BlendColor({
                    color: '#' + hexCOLOR_HILO,
                    mode: 'tint',
                  });

                  let oImgPuntada = imgPuntada.set({
                    left: 0,
                    top: 0,
                  });

                  oImgPuntada.filters.push(filter);

                  oImgPuntada.scaleToWidth(that.canvas[1].getWidth());

                  oImgPuntada.applyFilters();

                  that.canvas[1].add(oImgPuntada);
                  that.canvas[1].bringToFront(oImgPuntada);

                  that.canvas[1].renderAll();
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );
        });
      } else if (isServilletaMesaFlecos) {
        const COLOR_HILO = this.getValueForAttributeType('HILO').selector_inputs
          .value;

        const PUNTADA = this.getValueForAttributeType('PUNTADA').selector_inputs
          .value;

        const TELA_A = this.getValueForAttributeType('TELA').selector_inputs
          .value;

        let url_puntada = null;
        let url_flecos = null;
        let url_tela_fleco_A = null;

        let promises = [];

        promises.push(this.getColorInfo(COLOR_HILO));
        promises.push(this.getStitchInfo(PUNTADA));
        promises.push(this.getFabricInfo(TELA_A));

        Promise.all(promises).then((x) => {
          // const nameTAMANO = this.getValueForAttributeType(
          //   'TAMANO_DIAM'
          // ).selector_inputs.name.toUpperCase();

          const hexCOLOR_HILO = x[0][0].code_hex;
          const namePUNTADA = x[1].reference
            .toUpperCase()
            .replaceAll(' ', '_')
            .replaceAll('Ó', 'O');

          const TELA_A_INFO = x[2];

          let colorTelaAHex = '#ebebeb';

          if (TELA_A_INFO['primary_color_code_hex']) {
            colorTelaAHex = TELA_A_INFO['primary_color_code_hex'];
          }

          /// Si la tela está en formato imagen, mostramos esa -sólo estará disponible para telas complicadas-

          ///////////////

          const NAME_TELA_A = x[2].reference.toUpperCase().replaceAll(' ', '_');

          url_tela_fleco_A =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS_TELAS/' +
            `${NAME_TELA_A}/Tela.png`;

          url_flecos =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS/' +
            `ESTANDAR3.png`;

          url_puntada =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            `/PUNTADAS/` +
            `MESA_FLECOS_${namePUNTADA}_BLACK.png`;

          // View A INDIVIDUAL FLECOS

          // Error - image does not exist. Render and add fleco and puntada.
          let viewsByID = {
            A: 0,
          };

          // Show SVG group
          that.canvas[0].getObjects().map((y) => {
            if (y.type === 'group') {
              y.opacity = 1;
            }
          });

          that.renderTELA(that.attributes[1], viewsByID);

          fabric.Image.fromURL(
            url_flecos,
            function (imgFlecoA) {
              imgFlecoA.set({ id: 'imgfleco' });

              imgFlecoA.set({ left: 0, top: 0 });

              imgFlecoA.scaleToWidth(that.canvas[0].getWidth());

              that.canvas[0].add(imgFlecoA);
              that.canvas[0].bringToFront(imgFlecoA);

              fabric.Image.fromURL(
                url_puntada,
                function (imgPuntada) {
                  imgPuntada.set({ id: 'imgpuntada' });
                  const filter = new fabric.Image.filters.BlendColor({
                    color: '#' + hexCOLOR_HILO,
                    mode: 'tint',
                  });

                  let oImgPuntada = imgPuntada.set({ left: 0, top: 0 });

                  oImgPuntada.filters.push(filter);

                  oImgPuntada.scaleToWidth(that.canvas[0].getWidth());

                  oImgPuntada.applyFilters();

                  that.canvas[0].add(oImgPuntada);
                  that.canvas[0].bringToFront(oImgPuntada);

                  that.canvas[0].renderAll();
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );
        });
      } else if (isServilletaMeriendaFlecos) {
        const COLOR_HILO = this.getValueForAttributeType('HILO').selector_inputs
          .value;

        const PUNTADA = this.getValueForAttributeType('PUNTADA').selector_inputs
          .value;

        const TELA_A = this.getValueForAttributeType('TELA').selector_inputs
          .value;

        let url_puntada = null;
        let url_flecos = null;
        let url_tela_fleco_A = null;

        let promises = [];

        promises.push(this.getColorInfo(COLOR_HILO));
        promises.push(this.getStitchInfo(PUNTADA));
        promises.push(this.getFabricInfo(TELA_A));

        Promise.all(promises).then((x) => {
          // const nameTAMANO = this.getValueForAttributeType(
          //   'TAMANO_DIAM'
          // ).selector_inputs.name.toUpperCase();

          const hexCOLOR_HILO = x[0][0].code_hex;
          const namePUNTADA = x[1].reference
            .toUpperCase()
            .replaceAll(' ', '_')
            .replaceAll('Ó', 'O');

          const TELA_A_INFO = x[2];

          let colorTelaAHex = '#ebebeb';

          if (TELA_A_INFO['primary_color_code_hex']) {
            colorTelaAHex = TELA_A_INFO['primary_color_code_hex'];
          }

          /// Si la tela está en formato imagen, mostramos esa -sólo estará disponible para telas complicadas-

          ///////////////

          const NAME_TELA_A = x[2].reference.toUpperCase().replaceAll(' ', '_');

          url_tela_fleco_A =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS_TELAS/' +
            `${NAME_TELA_A}.png`;

          url_flecos =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS/' +
            `ESTANDAR2.png`;

          url_puntada =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            `/PUNTADAS/` +
            `${namePUNTADA}_BLACK.png`;

          // Error - image does not exist. Render and add fleco and puntada.
          let viewsByID = {
            A: 0,
          };

          // Show SVG group
          that.canvas[0].getObjects().map((y) => {
            if (y.type === 'group') {
              y.opacity = 1;
            }
          });

          that.renderTELA(that.attributes[1], viewsByID);

          fabric.Image.fromURL(
            url_flecos,
            function (imgFlecoA) {
              imgFlecoA.set({ id: 'imgfleco' });

              imgFlecoA.set({ left: 0, top: 0 });

              imgFlecoA.scaleToWidth(that.canvas[0].getWidth());

              that.canvas[0].add(imgFlecoA);
              that.canvas[0].bringToFront(imgFlecoA);

              fabric.Image.fromURL(
                url_puntada,
                function (imgPuntada) {
                  imgPuntada.set({ id: 'imgpuntada' });
                  const filter = new fabric.Image.filters.BlendColor({
                    color: '#' + hexCOLOR_HILO,
                    mode: 'tint',
                  });

                  let oImgPuntada = imgPuntada.set({ left: 0, top: 0 });

                  oImgPuntada.filters.push(filter);

                  oImgPuntada.scaleToWidth(that.canvas[0].getWidth());

                  oImgPuntada.applyFilters();

                  that.canvas[0].add(oImgPuntada);
                  that.canvas[0].bringToFront(oImgPuntada);

                  that.canvas[0].renderAll();
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );
        });
      } else if (isServilletaMesaFlecosAplicado) {
        const COLOR_HILO = this.getValueForAttributeType('HILO').selector_inputs
          .value;

        const PUNTADA = this.getValueForAttributeType('PUNTADA').selector_inputs
          .value;

        const TELA_A = this.getValueForAttributeTypeAndName('TELA', 'Tela')
          .selector_inputs.value;

        const APLIQUE = this.getValueForAttributeTypeAndName('TELA', 'Aplique')
          .selector_inputs.value;

        let url_puntada = null;
        let url_flecos_A = null;
        let url_flecos_aplique = null;

        let promises = [];

        promises.push(this.getColorInfo(COLOR_HILO));
        promises.push(this.getStitchInfo(PUNTADA));
        promises.push(this.getFabricInfo(TELA_A));
        promises.push(this.getFabricInfo(APLIQUE));

        Promise.all(promises).then((x) => {
          // const nameTAMANO = this.getValueForAttributeType(
          //   'TAMANO_DIAM'
          // ).selector_inputs.name.toUpperCase();

          const hexCOLOR_HILO = x[0][0].code_hex;
          const namePUNTADA = x[1].reference
            .toUpperCase()
            .replaceAll(' ', '_')
            .replaceAll('Ó', 'O');

          const TELA_A_INFO = x[2];
          const TELA_APLIQUE_INFO = x[3];

          let colorTelaAHex = '#ebebeb';
          let colorApliqueHex = '#ebebeb';

          if (TELA_A_INFO['primary_color_code_hex']) {
            colorTelaAHex = TELA_A_INFO['primary_color_code_hex'];
          }

          if (TELA_APLIQUE_INFO['primary_color_code_hex']) {
            colorApliqueHex = TELA_APLIQUE_INFO['primary_color_code_hex'];
          }

          let flecoTypeTelaA = 'ESTANDAR3.png';

          /// Si la tela está en formato imagen, mostramos esa -sólo estará disponible para telas complicadas-

          ///////////////

          const NAME_TELA_A = x[2].reference.toUpperCase().replaceAll(' ', '_');

          url_flecos_A =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS/' +
            flecoTypeTelaA;

          url_flecos_aplique =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS_APLIQUE/' +
            `ESTANDAR.png`;

          url_puntada =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            `/PUNTADAS/` +
            `MESA_FLECOS_${namePUNTADA}_BLACK.png`;

          // Error - image does not exist. Render and add fleco and puntada.
          let viewsByID = {
            A: 0,
          };

          // Show SVG group
          that.canvas[0].getObjects('group').map((y) => {
            if (y.type === 'group') {
              y.opacity = 1;
            }
          });

          that.renderTELA(that.attributes[1], viewsByID);
          // that.renderTELA(that.attributes[3], viewsByID);

          fabric.Image.fromURL(
            url_flecos_A,
            function (imgFlecoA) {
              imgFlecoA.set({ id: 'imgfleco' });

              imgFlecoA.set({ left: 0, top: 0 });

              imgFlecoA.scaleToWidth(that.canvas[0].getWidth());

              that.canvas[0].add(imgFlecoA);
              that.canvas[0].bringToFront(imgFlecoA);

              fabric.Image.fromURL(
                url_flecos_aplique,
                function (imgFlecosAplique) {
                  imgFlecosAplique.set({ id: 'imgflecoaplique' });

                  const filterFlecoAplique = new fabric.Image.filters.BlendColor(
                    {
                      color: colorApliqueHex,
                      mode: 'tint',
                    }
                  );

                  imgFlecosAplique.set({ left: 0, top: 0 });

                  imgFlecosAplique.filters.push(filterFlecoAplique);

                  imgFlecosAplique.applyFilters();

                  imgFlecosAplique.scaleToWidth(that.canvas[0].getWidth());

                  that.canvas[0].add(imgFlecosAplique);
                  that.canvas[0].bringToFront(imgFlecosAplique);

                  fabric.Image.fromURL(
                    url_puntada,
                    function (imgPuntada) {
                      imgPuntada.set({ id: 'imgpuntada' });
                      const filter = new fabric.Image.filters.BlendColor({
                        color: '#' + hexCOLOR_HILO,
                        mode: 'tint',
                      });

                      let oImgPuntada = imgPuntada.set({
                        left: 0,
                        top: 0,
                      });

                      oImgPuntada.filters.push(filter);

                      oImgPuntada.scaleToWidth(that.canvas[0].getWidth());

                      oImgPuntada.applyFilters();

                      that.canvas[0].add(oImgPuntada);
                      that.canvas[0].bringToFront(oImgPuntada);

                      that.canvas[0].renderAll();
                    },
                    { crossOrigin: 'Anonymous' }
                  );
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );
        });
      } else if (isServilletaCocktailFlecos) {
        const COLOR_HILO = this.getValueForAttributeType('HILO').selector_inputs
          .value;

        const PUNTADA = this.getValueForAttributeType('PUNTADA').selector_inputs
          .value;

        const TELA_A = this.getValueForAttributeType('TELA').selector_inputs
          .value;

        let url_puntada = null;
        let url_flecos = null;

        let promises = [];

        promises.push(this.getColorInfo(COLOR_HILO));
        promises.push(this.getStitchInfo(PUNTADA));
        promises.push(this.getFabricInfo(TELA_A));

        Promise.all(promises).then((x) => {
          // const nameTAMANO = this.getValueForAttributeType(
          //   'TAMANO_DIAM'
          // ).selector_inputs.name.toUpperCase();

          const hexCOLOR_HILO = x[0][0].code_hex;
          const namePUNTADA = x[1].reference
            .toUpperCase()
            .replaceAll(' ', '_')
            .replaceAll('Ó', 'O');

          /// Si la tela está en formato imagen, mostramos esa -sólo estará disponible para telas complicadas-

          ///////////////

          url_flecos =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS/' +
            `ESTANDAR2.png`;

          url_puntada =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            `/PUNTADAS/` +
            `${namePUNTADA}_BLACK.png`;

          // View A INDIVIDUAL FLECOS

          // Error - image does not exist. Render and add fleco and puntada.
          let viewsByID = {
            A: 0,
          };

          // Show SVG group
          that.canvas[0].getObjects().map((y) => {
            if (y.type === 'group') {
              y.opacity = 1;
            }
          });

          that.renderTELA(that.attributes[1], viewsByID);

          fabric.Image.fromURL(
            url_flecos,
            function (imgFlecoA) {
              imgFlecoA.set({ id: 'imgfleco' });

              imgFlecoA.set({ left: 0, top: 0 });

              imgFlecoA.scaleToWidth(that.canvas[0].getWidth());

              that.canvas[0].add(imgFlecoA);
              that.canvas[0].bringToFront(imgFlecoA);

              fabric.Image.fromURL(
                url_puntada,
                function (imgPuntada) {
                  imgPuntada.set({ id: 'imgpuntada' });
                  const filter = new fabric.Image.filters.BlendColor({
                    color: '#' + hexCOLOR_HILO,
                    mode: 'tint',
                  });

                  let oImgPuntada = imgPuntada.set({ left: 0, top: 0 });

                  oImgPuntada.filters.push(filter);

                  oImgPuntada.scaleToWidth(that.canvas[0].getWidth());

                  oImgPuntada.applyFilters();

                  that.canvas[0].add(oImgPuntada);
                  that.canvas[0].bringToFront(oImgPuntada);

                  that.canvas[0].renderAll();
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );
        });
      } else if (isCaminoMesaFlecos) {
        const COLOR_HILO = this.getValueForAttributeType('HILO').selector_inputs
          .value;

        const PUNTADA = this.getValueForAttributeType('PUNTADA').selector_inputs
          .value;

        const TELA_A = this.getValueForAttributeTypeAndName(
          'TELA',
          'Tela Cara A'
        ).selector_inputs.value;

        let url_puntada = null;
        let url_flecos_A = null;

        let promises = [];

        promises.push(this.getColorInfo(COLOR_HILO));
        promises.push(this.getStitchInfo(PUNTADA));
        promises.push(this.getFabricInfo(TELA_A));

        Promise.all(promises).then((x) => {
          // const nameTAMANO = this.getValueForAttributeType(
          //   'TAMANO_DIAM'
          // ).selector_inputs.name.toUpperCase();

          const hexCOLOR_HILO = x[0][0].code_hex;
          const namePUNTADA = x[1].reference
            .toUpperCase()
            .replaceAll(' ', '_')
            .replaceAll('Ó', 'O');

          const TELA_A_INFO = x[2];
          const TELA_B_INFO = x[3];

          // if (TELA_A_INFO['primary_color_code_hex']) {
          //   colorTelaAHex = TELA_A_INFO['primary_color_code_hex'];
          // }
          // if (TELA_B_INFO['primary_color_code_hex']) {
          //   colorTelaBHex = TELA_B_INFO['primary_color_code_hex'];
          // }

          let flecoTypeTelaA =
            TELA_A_INFO['extra_type'] === 'FLECOS_IND_LAT_BLANCOS'
              ? 'ESTANDAR2_LAT_WHITE.png'
              : 'ESTANDAR2_FULL.png';

          /// Si la tela está en formato imagen, mostramos esa -sólo estará disponible para telas complicadas-

          ///////////////

          url_flecos_A =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS/' +
            flecoTypeTelaA;

          url_puntada =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            `/PUNTADAS/` +
            `FLECO_INDIVIDUAL_${namePUNTADA}_BLACK.png`;

          // View A INDIVIDUAL FLECOS

          // Error - image does not exist. Render and add fleco and puntada.
          let viewsByID = {
            A: 0,
          };

          // Show SVG group
          that.canvas[0].getObjects().map((y) => {
            if (y.type === 'group') {
              y.opacity = 1;
            }
          });

          that.renderTELA(that.attributes[1], viewsByID);

          fabric.Image.fromURL(
            url_flecos_A,
            function (imgFlecoA) {
              imgFlecoA.set({ id: 'imgfleco' });

              imgFlecoA.set({ left: 0, top: 0 });

              imgFlecoA.scaleToWidth(that.canvas[0].getWidth());

              that.canvas[0].add(imgFlecoA);
              that.canvas[0].bringToFront(imgFlecoA);

              fabric.Image.fromURL(
                url_puntada,
                function (imgPuntada) {
                  imgPuntada.set({ id: 'imgpuntada' });
                  const filter = new fabric.Image.filters.BlendColor({
                    color: '#' + hexCOLOR_HILO,
                    mode: 'tint',
                  });

                  let oImgPuntada = imgPuntada.set({ left: 0, top: 0 });

                  oImgPuntada.filters.push(filter);

                  oImgPuntada.scaleToWidth(that.canvas[0].getWidth());

                  oImgPuntada.applyFilters();

                  that.canvas[0].add(oImgPuntada);
                  that.canvas[0].bringToFront(oImgPuntada);

                  that.canvas[0].renderAll();
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );
        });
      } else if (isCaminoMesaMust) {
        const COLOR_HILO = this.getValueForAttributeType('HILO').selector_inputs
          .value;

        const PUNTADA = this.getValueForAttributeType('PUNTADA').selector_inputs
          .value;

        const TELA_A = this.getValueForAttributeTypeAndName(
          'TELA',
          'Tela Cara A'
        ).selector_inputs.value;

        let url_puntada = null;
        let url_flecos_A = null;

        let promises = [];

        promises.push(this.getColorInfo(COLOR_HILO));
        promises.push(this.getStitchInfo(PUNTADA));
        promises.push(this.getFabricInfo(TELA_A));

        Promise.all(promises).then((x) => {
          // const nameTAMANO = this.getValueForAttributeType(
          //   'TAMANO_DIAM'
          // ).selector_inputs.name.toUpperCase();

          const hexCOLOR_HILO = x[0][0].code_hex;
          const namePUNTADA = x[1].reference
            .toUpperCase()
            .replaceAll(' ', '_')
            .replaceAll('Ó', 'O');

          const TELA_A_INFO = x[2];

          /// Si la tela está en formato imagen, mostramos esa -sólo estará disponible para telas complicadas-

          ///////////////

          url_puntada =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            `/PUNTADAS/` +
            `FLECO_INDIVIDUAL_${namePUNTADA}_BLACK.png`;

          // View A INDIVIDUAL FLECOS

          // Error - image does not exist. Render and add fleco and puntada.
          let viewsByID = {
            A: 0,
          };

          // Show SVG group
          that.canvas[0].getObjects().map((y) => {
            if (y.type === 'group') {
              y.opacity = 1;
            }
          });

          that.renderTELA(that.attributes[1], viewsByID);

          fabric.Image.fromURL(
            url_puntada,
            function (imgPuntada) {
              imgPuntada.set({ id: 'imgpuntada' });
              const filter = new fabric.Image.filters.BlendColor({
                color: '#' + hexCOLOR_HILO,
                mode: 'tint',
              });

              let oImgPuntada = imgPuntada.set({ left: 0, top: 0 });

              oImgPuntada.filters.push(filter);

              oImgPuntada.scaleToWidth(that.canvas[0].getWidth());

              oImgPuntada.applyFilters();

              that.canvas[0].add(oImgPuntada);
              that.canvas[0].bringToFront(oImgPuntada);

              that.canvas[0].renderAll();
            },
            { crossOrigin: 'Anonymous' }
          );
        });
      } else if (isCaminoMesaFlecosAplicado) {
        const COLOR_HILO = this.getValueForAttributeType('HILO').selector_inputs
          .value;

        const PUNTADA = this.getValueForAttributeType('PUNTADA').selector_inputs
          .value;

        const TELA_A = this.getValueForAttributeTypeAndName(
          'TELA',
          'Tela Cara A'
        ).selector_inputs.value;

        const APLIQUE = this.getValueForAttributeTypeAndName('TELA', 'Aplique')
          .selector_inputs.value;

        let url_puntada = null;
        let url_flecos_tela = null;
        let url_tela_fleco_A = null;
        let url_tela_fleco_B = null;
        let url_flecos_aplique = null;
        let url_flecos_A = null;
        let url_flecos_B = null;

        let promises = [];

        promises.push(this.getColorInfo(COLOR_HILO));
        promises.push(this.getStitchInfo(PUNTADA));
        promises.push(this.getFabricInfo(TELA_A));
        promises.push(this.getFabricInfo(APLIQUE));

        Promise.all(promises).then((x) => {
          // const nameTAMANO = this.getValueForAttributeType(
          //   'TAMANO_DIAM'
          // ).selector_inputs.name.toUpperCase();

          const hexCOLOR_HILO = x[0][0].code_hex;
          const namePUNTADA = x[1].reference
            .toUpperCase()
            .replaceAll(' ', '_')
            .replaceAll('Ó', 'O');

          const TELA_A_INFO = x[2];
          const TELA_APLIQUE_INFO = x[3];

          let colorTelaAHex = '#ebebeb';
          let colorApliqueHex = '#ebebeb';

          if (TELA_A_INFO['primary_color_code_hex']) {
            colorTelaAHex = TELA_A_INFO['primary_color_code_hex'];
          }

          if (TELA_APLIQUE_INFO['primary_color_code_hex']) {
            colorApliqueHex = TELA_APLIQUE_INFO['primary_color_code_hex'];
          }

          let flecoTypeTelaA =
            TELA_A_INFO['extra_type'] === 'FLECOS_IND_LAT_BLANCOS'
              ? 'ESTANDAR2_LAT_WHITE.png'
              : 'ESTANDAR2_FULL.png';

          /// Si la tela está en formato imagen, mostramos esa -sólo estará disponible para telas complicadas-

          ///////////////

          const NAME_TELA_A = x[2].reference.toUpperCase().replaceAll(' ', '_');

          url_flecos_A =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS/' +
            flecoTypeTelaA;

          url_flecos_aplique =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            '/FLECOS_APLIQUE/' +
            `ESTANDAR.png`;

          url_puntada =
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
            'uploads/product_templates/' +
            this.productData.template +
            `/PUNTADAS/` +
            `FLECO_INDIVIDUAL_${namePUNTADA}_BLACK.png`;

          // Error - image does not exist. Render and add fleco and puntada.
          let viewsByID = {
            A: 0,
          };

          // Show SVG group
          that.canvas[0].getObjects('group').map((y) => {
            y.opacity = 1;

            y.getObjects().map((zz) => {
              zz.opacity = 1;
            });
          });

          that.renderTELA(that.attributes[1], viewsByID);
          // that.renderTELA(that.attributes[3], viewsByID);

          fabric.Image.fromURL(
            url_flecos_A,
            function (imgFlecoA) {
              imgFlecoA.set({ id: 'imgfleco' });

              imgFlecoA.set({ left: 0, top: 0 });

              imgFlecoA.scaleToWidth(that.canvas[0].getWidth());

              that.canvas[0].add(imgFlecoA);
              that.canvas[0].bringToFront(imgFlecoA);

              fabric.Image.fromURL(
                url_flecos_aplique,
                function (imgFlecosAplique) {
                  imgFlecosAplique.set({ id: 'imgflecoaplique' });

                  const filterFlecoAplique = new fabric.Image.filters.BlendColor(
                    {
                      color: colorApliqueHex,
                      mode: 'tint',
                    }
                  );

                  imgFlecosAplique.set({ left: 0, top: 0 });

                  imgFlecosAplique.filters.push(filterFlecoAplique);

                  imgFlecosAplique.applyFilters();

                  imgFlecosAplique.scaleToWidth(that.canvas[0].getWidth());

                  that.canvas[0].add(imgFlecosAplique);
                  that.canvas[0].bringToFront(imgFlecosAplique);

                  fabric.Image.fromURL(
                    url_puntada,
                    function (imgPuntada) {
                      imgPuntada.set({ id: 'imgpuntada' });
                      const filter = new fabric.Image.filters.BlendColor({
                        color: '#' + hexCOLOR_HILO,
                        mode: 'tint',
                      });

                      let oImgPuntada = imgPuntada.set({
                        left: 0,
                        top: 0,
                      });

                      oImgPuntada.filters.push(filter);

                      oImgPuntada.scaleToWidth(that.canvas[0].getWidth());

                      oImgPuntada.applyFilters();

                      that.canvas[0].add(oImgPuntada);
                      that.canvas[0].bringToFront(oImgPuntada);

                      that.canvas[0].renderAll();
                    },
                    { crossOrigin: 'Anonymous' }
                  );
                },
                { crossOrigin: 'Anonymous' }
              );
            },
            { crossOrigin: 'Anonymous' }
          );
        });
      }
    },

    getProductPreview() {
      if (!this.three.initialized) {
        let that = this;
        let arr = [];
        for (let index = 0; index < that.canvas.length; index++) {
          let pngURI = that.canvas[index].toDataURL({
            format: 'png',
          });
          arr.push(pngURI);
        }
        return arr;
      } else {
        let arr = [];
        let pngURI = this.three.renderer.domElement.toDataURL();
        arr.push(pngURI);
        return arr;
      }
    },
    addProductModalBtn(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (this.checkCustomizerErrors()) {
        return false;
      }

      const images = this.getProductPreview();

      if (this.editData) {
        this.$emit(
          'editProduct',
          this.productData,
          this.attributes,
          this.currentPrice,
          this.quantity,
          this.comments,
          images
        );
      } else {
        this.$emit(
          'addProduct',
          this.productData,
          this.attributes,
          this.currentPrice,
          this.quantity,
          this.comments,
          images
        );
      }

      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing');
      });
    },
    setupStitchTop(element, loadedObject, viewCanvas) {
      const scaleXMarco = element.group.scaleX;
      const scaleYMarco = element.group.scaleY;

      const stitchSVGObject = fabric.util.object.clone(
        loadedObject[0].fabricObj
      );

      const stitchSVGObjectWidth = stitchSVGObject.width;
      const stitchSVGObjectHeight = stitchSVGObject.height; // should be the same as stitchSVGHeight

      let myleft = (element.left + element.group.width / 2) * scaleXMarco;

      let myTop = (element.top + element.group.height / 2) * scaleYMarco;

      const routeType = loadedObject[0].route_type; // simple / overlapped

      // myTop -= (element.height / 2) * scaleYMarco;

      const stitchDesiredHeight = fabric.util.parseUnit(
        loadedObject[0].sizes[this.stitch_size].height + 'cm'
      );
      const stitchSVGHeight = fabric.util.parseUnit(
        loadedObject[0].heightCM + 'cm'
      );

      //debugger;
      let rectWidth = element.width;

      const isServilletaWithPuntada = [
        'SERV_MESA_MUST',
        'SERV_MERI_MUST',
        'SERV_COCKT_MUST',
      ].includes(this.productData.template);

      if (routeType === 'overlapped' && !isServilletaWithPuntada) {
        myleft -= (stitchDesiredHeight - element.height) * scaleYMarco;
        rectWidth += 2 * (stitchDesiredHeight - element.height);
        //rectWidth = rectWidth + 38;
      } else if (!isServilletaWithPuntada) {
        myleft -= 2;
        rectWidth += 6;
      }

      const stitchRatio = stitchSVGObjectWidth / stitchSVGHeight;
      const stitchAdjustedWidth = stitchDesiredHeight * stitchRatio;

      let newRatioPuntadaServiMust = stitchDesiredHeight / stitchSVGHeight;

      const optionsRest = {
        strokeWidth: 0,

        width: rectWidth,
        height: stitchDesiredHeight,
        left: myleft,
        top: myTop - (stitchDesiredHeight - element.height) * scaleYMarco,
        scaleX: scaleXMarco,
        scaleY: scaleYMarco,
        flipY: true,
      };

      const optionsServilletaWithPuntada = {
        strokeWidth: 0,

        width: rectWidth / newRatioPuntadaServiMust,
        height: stitchDesiredHeight / newRatioPuntadaServiMust - 3,
        left: myleft,
        top: myTop,
        scaleX: scaleXMarco * newRatioPuntadaServiMust,
        scaleY: scaleYMarco * newRatioPuntadaServiMust,
        flipY: true,
      };

      const rect = new fabric.Rect(
        isServilletaWithPuntada ? optionsServilletaWithPuntada : optionsRest
      );

      stitchSVGObject.set({
        fill: '#' + loadedObject[1],
        strokeWidth: 0,
      });

      rect['myType'] = 'stitch';

      let patternSourceCanvasPuntada = new fabric.StaticCanvas(null, {
        enableRetinaScaling: false,
      });

      //let newRatio =

      patternSourceCanvasPuntada.setDimensions({
        width: stitchSVGObjectWidth - 1,
        height: stitchSVGHeight,
      });

      patternSourceCanvasPuntada.add(stitchSVGObject).renderAll();

      const pattern = new fabric.Pattern({
        source: patternSourceCanvasPuntada.getElement(),
        repeat: 'repeat',
      });

      rect.set('fill', pattern);
      // this.canvas[viewCanvas].add(shape);

      return rect;
    },
    setupStitchBottom(element, loadedObject, viewCanvas) {
      const scaleXMarco = element.group.scaleX;
      const scaleYMarco = element.group.scaleY;

      const stitchSVGObject = fabric.util.object.clone(
        loadedObject[0].fabricObj
      );

      const stitchSVGObjectWidth = stitchSVGObject.width;
      const stitchSVGObjectHeight = stitchSVGObject.height; // should be the same as stitchSVGHeight

      let myleft = (element.left + element.group.width / 2) * scaleXMarco;

      let myTop = (element.top + element.group.height / 2) * scaleYMarco;

      // myTop -= (element.height / 2) * element.group.scaleY;
      const routeType = loadedObject[0].route_type; // simple / overlapped

      const stitchDesiredHeight = fabric.util.parseUnit(
        loadedObject[0].sizes[this.stitch_size].height + 'cm'
      );
      const stitchSVGHeight = fabric.util.parseUnit(
        loadedObject[0].heightCM + 'cm'
      );
      // const heightCM = fabric.util.parseUnit(loadedObject[0].heightCM + 'cm');

      let rectWidth = element.width;

      const isServilletaWithPuntada = [
        'SERV_MESA_MUST',
        'SERV_MERI_MUST',
        'SERV_COCKT_MUST',
      ].includes(this.productData.template); // only servilleta mesa having puntada

      if (routeType === 'overlapped' && !isServilletaWithPuntada) {
        myleft -= (stitchDesiredHeight - element.height) * scaleYMarco;
        rectWidth += 2 * (stitchDesiredHeight - element.height);
        //rectWidth = rectWidth + 38;
      } else {
      }

      const stitchRatio = stitchSVGObjectWidth / stitchSVGHeight;
      const stitchAdjustedWidth = stitchDesiredHeight * stitchRatio;

      let newRatioPuntadaServiMust = stitchDesiredHeight / stitchSVGHeight;

      const optionsServilletaWithPuntada = {
        strokeWidth: 0,

        width: rectWidth / newRatioPuntadaServiMust,
        height: stitchDesiredHeight / newRatioPuntadaServiMust - 3,
        left: myleft,
        top: myTop,
        scaleX: scaleXMarco * newRatioPuntadaServiMust,
        scaleY: scaleYMarco * newRatioPuntadaServiMust,
      };

      const optionsRest = {
        strokeWidth: 0,

        width: rectWidth,
        height: stitchDesiredHeight,
        left: myleft,
        top: myTop,
        scaleX: scaleXMarco,
        scaleY: scaleYMarco,
      };

      const rect = new fabric.Rect(
        isServilletaWithPuntada ? optionsServilletaWithPuntada : optionsRest
      );

      stitchSVGObject.set({
        strokeWidth: 0,
      });

      stitchSVGObject.set({
        fill: '#' + loadedObject[1],
      });

      rect['myType'] = 'stitch';

      let patternSourceCanvasPuntada = new fabric.StaticCanvas(null, {
        enableRetinaScaling: false,
      });

      //let newRatio =

      patternSourceCanvasPuntada.setDimensions({
        width: stitchSVGObjectWidth - 1,
        height: stitchSVGHeight,
      });

      patternSourceCanvasPuntada.add(stitchSVGObject).renderAll();

      const pattern = new fabric.Pattern({
        source: patternSourceCanvasPuntada.getElement(),
        repeat: 'repeat',
      });

      rect.set('fill', pattern);
      // this.canvas[viewCanvas].add(shape);

      return rect;
    },
    setupStitchLeft(element, loadedObject) {
      const scaleXMarco = element.group.scaleX;
      const scaleYMarco = element.group.scaleY;

      const stitchSVGObject = fabric.util.object.clone(
        loadedObject[0].fabricObj
      );

      const stitchSVGObjectWidth = stitchSVGObject.width;
      const stitchSVGObjectHeight = stitchSVGObject.height; // should be the same as stitchSVGHeight

      let myleft = (element.left + element.group.width / 2) * scaleXMarco;

      let myTop = (element.top + element.group.height / 2) * scaleYMarco;

      const routeType = loadedObject[0].route_type; // simple / overlapped

      const stitchDesiredHeight = fabric.util.parseUnit(
        loadedObject[0].sizes[this.stitch_size].height + 'cm'
      );
      const stitchSVGHeight = fabric.util.parseUnit(
        loadedObject[0].heightCM + 'cm'
      );

      let rectWidth = element.width;

      const isServilletaWithPuntada = [
        'SERV_MESA_MUST',
        'SERV_MERI_MUST',
        'SERV_COCKT_MUST',
      ].includes(this.productData.template); // only servilleta mesa having puntada

      if (routeType === 'overlapped' && !isServilletaWithPuntada) {
        myTop -= (stitchDesiredHeight - element.height) * scaleYMarco;
        rectWidth += 2 * (stitchDesiredHeight - element.height);
        //rectWidth = rectWidth + 38;
      } else {
      }

      const stitchRatio = stitchSVGObjectWidth / stitchSVGHeight;
      const stitchAdjustedWidth = stitchDesiredHeight * stitchRatio;
      let newRatioPuntadaServiMust = stitchDesiredHeight / stitchSVGHeight;

      const optionsServilletaWithPuntada = {
        strokeWidth: 0,

        width: rectWidth / newRatioPuntadaServiMust,
        height: stitchDesiredHeight / newRatioPuntadaServiMust - 3,
        left: myleft,
        top: myTop,
        scaleX: scaleXMarco * newRatioPuntadaServiMust,
        scaleY: scaleYMarco * newRatioPuntadaServiMust,
      };

      const optionsRest = {
        strokeWidth: 0,

        width: rectWidth,
        height: stitchDesiredHeight,
        left: myleft,
        top: myTop,
        scaleX: scaleXMarco,
        scaleY: scaleYMarco,
        //opacity: 0.5,
      };

      const rect = new fabric.Rect(
        isServilletaWithPuntada ? optionsServilletaWithPuntada : optionsRest
      );

      stitchSVGObject.set({
        fill: '#' + loadedObject[1],
        strokeWidth: 0,
      });

      // stitchSVGObject.set({
      //   flipY: true,
      //   strokeWidth: 0,
      // });

      rect['myType'] = 'stitch';

      let patternSourceCanvasPuntada = new fabric.StaticCanvas(null, {
        enableRetinaScaling: false,
      });

      //let newRatio =

      patternSourceCanvasPuntada.setDimensions({
        width: stitchSVGObjectWidth - 1,
        height: stitchSVGHeight,
      });

      patternSourceCanvasPuntada.add(stitchSVGObject).renderAll();

      const pattern = new fabric.Pattern({
        source: patternSourceCanvasPuntada.getElement(),
        repeat: 'repeat-x',
      });

      rect.set('fill', pattern);
      rect.angle = 90;
      // this.canvas[viewCanvas].add(shape);

      return rect;
    },
    setupStitchRight(element, loadedObject, viewCanvas) {
      const scaleXMarco = element.group.scaleX;
      const scaleYMarco = element.group.scaleY;

      const stitchSVGObject = fabric.util.object.clone(
        loadedObject[0].fabricObj
      );

      const stitchSVGObjectWidth = stitchSVGObject.width;
      const stitchSVGObjectHeight = stitchSVGObject.height; // should be the same as stitchSVGHeight

      let myleft = (element.left + element.group.width / 2) * scaleXMarco;

      let myTop = (element.top + element.group.height / 2) * scaleYMarco;

      const stitchDesiredHeight = fabric.util.parseUnit(
        loadedObject[0].sizes[this.stitch_size].height + 'cm'
      );
      const stitchSVGHeight = fabric.util.parseUnit(
        loadedObject[0].heightCM + 'cm'
      );

      const routeType = loadedObject[0].route_type; // simple / overlapped

      let rectWidth = element.width;

      const isServilletaWithPuntada = [
        'SERV_MESA_MUST',
        'SERV_MERI_MUST',
        'SERV_COCKT_MUST',
      ].includes(this.productData.template); // only servilleta mesa having puntada

      if (routeType === 'overlapped' && !isServilletaWithPuntada) {
        myTop -= (stitchDesiredHeight - element.height) * scaleYMarco;
        rectWidth += 2 * (stitchDesiredHeight - element.height);
        myleft += (stitchDesiredHeight - element.height) * scaleYMarco;
      } else if (!isServilletaWithPuntada) {
        myleft += (stitchDesiredHeight - element.height) * scaleYMarco;
      }

      const stitchRatio = stitchSVGObjectWidth / stitchSVGHeight;
      const stitchAdjustedWidth = stitchDesiredHeight * stitchRatio;
      let newRatioPuntadaServiMust = stitchDesiredHeight / stitchSVGHeight;

      const optionsServilletaWithPuntada = {
        strokeWidth: 0,

        width: rectWidth / newRatioPuntadaServiMust,
        height: stitchDesiredHeight / newRatioPuntadaServiMust - 3,
        left: myleft,
        top: myTop,
        scaleX: scaleXMarco * newRatioPuntadaServiMust,
        scaleY: scaleYMarco * newRatioPuntadaServiMust,
        flipY: true,
      };

      const optionsRest = {
        strokeWidth: 0,
        width: rectWidth,
        height: stitchDesiredHeight,
        left: myleft,
        top: myTop,
        scaleX: scaleXMarco,
        scaleY: scaleYMarco,
        // opacity: 0.5,
        flipY: true,
      };

      const rect = new fabric.Rect(
        isServilletaWithPuntada ? optionsServilletaWithPuntada : optionsRest
      );

      stitchSVGObject.set({
        fill: '#' + loadedObject[1],
        strokeWidth: 0,
      });

      rect['myType'] = 'stitch';

      let patternSourceCanvasPuntada = new fabric.StaticCanvas(null, {
        enableRetinaScaling: false,
      });

      //let newRatio =

      patternSourceCanvasPuntada.setDimensions({
        width: stitchSVGObjectWidth - 1,
        height: stitchSVGHeight,
      });

      patternSourceCanvasPuntada.add(stitchSVGObject).renderAll();

      const pattern = new fabric.Pattern({
        source: patternSourceCanvasPuntada.getElement(),
        repeat: 'repeat-x',
      });

      rect.set('fill', pattern);
      rect.angle = 90;
      // this.canvas[viewCanvas].add(shape);

      return rect;
    },

    setupStitchRotatedLB(element, loadedObject, viewCanvas) {
      const scaleXMarco = element.group.scaleX;
      const scaleYMarco = element.group.scaleY;

      const stitchSVGObject = fabric.util.object.clone(
        loadedObject[0].fabricObj
      );

      const stitchSVGObjectWidth = stitchSVGObject.width;
      const stitchSVGObjectHeight = stitchSVGObject.height; // should be the same as stitchSVGHeight

      let myleft = (element.left + element.group.width / 2) * scaleXMarco;

      let myTop = (element.top + element.group.height / 2) * scaleYMarco;

      const routeType = loadedObject[0].route_type; // simple / overlapped

      const stitchDesiredHeight = fabric.util.parseUnit(
        loadedObject[0].sizes[this.stitch_size].height + 'cm'
      );
      const stitchSVGHeight = fabric.util.parseUnit(
        loadedObject[0].heightCM + 'cm'
      );

      let rectWidth = element.width;

      const isServilletaWithPuntada = [
        'SERV_MESA_MUST',
        'SERV_MERI_MUST',
      ].includes(this.productData.template); // only servilleta mesa having puntada

      if (routeType === 'overlapped' && !isServilletaWithPuntada) {
        myTop -= (stitchDesiredHeight - element.height) * scaleYMarco;
        rectWidth += 2 * (stitchDesiredHeight - element.height);
        //rectWidth = rectWidth + 38;
      } else {
      }

      const stitchRatio = stitchSVGObjectWidth / stitchSVGHeight;
      const stitchAdjustedWidth = stitchDesiredHeight * stitchRatio;
      let newRatioPuntadaServiMust = stitchDesiredHeight / stitchSVGHeight;

      const optionsServilletaWithPuntada = {
        strokeWidth: 0,

        width: rectWidth / newRatioPuntadaServiMust,
        height: stitchDesiredHeight / newRatioPuntadaServiMust - 3,
        left: myleft,
        top: myTop,
        scaleX: scaleXMarco * newRatioPuntadaServiMust,
        scaleY: scaleYMarco * newRatioPuntadaServiMust,
      };

      const optionsRest = {
        strokeWidth: 0,

        width: rectWidth,
        height: stitchDesiredHeight,
        left: myleft,
        top: myTop,
        scaleX: scaleXMarco,
        scaleY: scaleYMarco,
      };

      const rect = new fabric.Rect(
        isServilletaWithPuntada ? optionsServilletaWithPuntada : optionsRest
      );

      stitchSVGObject.set({
        fill: '#' + loadedObject[1],
        strokeWidth: 0,
      });

      // stitchSVGObject.set({
      //   flipY: true,
      //   strokeWidth: 0,
      // });

      rect['myType'] = 'stitch';

      let patternSourceCanvasPuntada = new fabric.StaticCanvas(null, {
        enableRetinaScaling: false,
      });

      //let newRatio =

      patternSourceCanvasPuntada.setDimensions({
        width: stitchSVGObjectWidth - 1,
        height: stitchSVGHeight,
      });

      patternSourceCanvasPuntada.add(stitchSVGObject).renderAll();

      const pattern = new fabric.Pattern({
        source: patternSourceCanvasPuntada.getElement(),
        repeat: 'repeat-x',
      });

      rect.set('fill', pattern);

      rect.angle = 45;
      // this.canvas[viewCanvas].add(shape);

      return rect;
    },
    setupStitchRotatedRB(element, loadedObject, viewCanvas) {
      const scaleXMarco = element.group.scaleX;
      const scaleYMarco = element.group.scaleY;

      const stitchSVGObject = fabric.util.object.clone(
        loadedObject[0].fabricObj
      );

      const stitchSVGObjectWidth = stitchSVGObject.width;
      const stitchSVGObjectHeight = stitchSVGObject.height; // should be the same as stitchSVGHeight

      let myleft = (element.left + element.group.width / 2) * scaleXMarco;

      let myTop = (element.top + element.group.height / 2) * scaleYMarco;

      const stitchDesiredHeight = fabric.util.parseUnit(
        loadedObject[0].sizes[this.stitch_size].height + 'cm'
      );
      const stitchSVGHeight = fabric.util.parseUnit(
        loadedObject[0].heightCM + 'cm'
      );

      const routeType = loadedObject[0].route_type; // simple / overlapped

      let rectWidth = element.width;

      const isServilletaWithPuntada = [
        'SERV_MESA_MUST',
        'SERV_MERI_MUST',
      ].includes(this.productData.template); // only servilleta mesa having puntada

      if (routeType === 'overlapped' && !isServilletaWithPuntada) {
        myTop -= (stitchDesiredHeight - element.height) * scaleYMarco;
        rectWidth += 2 * (stitchDesiredHeight - element.height);
        myleft += (stitchDesiredHeight - element.height) * scaleYMarco;
      } else if (!isServilletaWithPuntada) {
        myleft += (stitchDesiredHeight - element.height) * scaleYMarco;
      }

      const stitchRatio = stitchSVGObjectWidth / stitchSVGHeight;
      const stitchAdjustedWidth = stitchDesiredHeight * stitchRatio;

      let newRatioPuntadaServiMust = stitchDesiredHeight / stitchSVGHeight;

      const optionsServilletaWithPuntada = {
        strokeWidth: 0,

        width: rectWidth / newRatioPuntadaServiMust,
        height: stitchDesiredHeight / newRatioPuntadaServiMust - 3,
        left: myleft,
        top: myTop,
        scaleX: scaleXMarco * newRatioPuntadaServiMust,
        scaleY: scaleYMarco * newRatioPuntadaServiMust,
      };

      const optionsRest = {
        strokeWidth: 0,
        width: rectWidth,
        height: stitchDesiredHeight,
        left: myleft,
        top: myTop,
        scaleX: scaleXMarco,
        scaleY: scaleYMarco,
        // opacity: 0.5,
        flipY: true,
      };

      const rect = new fabric.Rect(
        isServilletaWithPuntada ? optionsServilletaWithPuntada : optionsRest
      );

      stitchSVGObject.set({
        fill: '#' + loadedObject[1],
        strokeWidth: 0,
      });

      rect['myType'] = 'stitch';

      let patternSourceCanvasPuntada = new fabric.StaticCanvas(null, {
        enableRetinaScaling: false,
      });

      //let newRatio =

      patternSourceCanvasPuntada.setDimensions({
        width: stitchSVGObjectWidth - 1,
        height: stitchSVGHeight,
      });

      patternSourceCanvasPuntada.add(stitchSVGObject).renderAll();

      const pattern = new fabric.Pattern({
        source: patternSourceCanvasPuntada.getElement(),
        repeat: 'repeat-x',
      });

      rect.set('fill', pattern);
      rect.angle = -45;
      // this.canvas[viewCanvas].add(shape);

      return rect;
    },

    getCloserNumber(arr, desired) {
      const output = arr.reduce((prev, curr) =>
        Math.abs(curr - desired) < Math.abs(prev - desired) ? curr : prev
      );

      return output;
    },
    calculateSelectedRatio() {
      const isMantel = [
        'MANTEL_MUST',
        'MANTEL_ABSOLUTE',
        'MANTEL_DOBLE_BOR',
        'MANTEL_BOR',
        'MANTEL_ONDAS',
        'MANTEL_FLECOS_APL',
        'MANTEL_FLECOS',
      ].includes(this.productData.template);
      const hasTAMANO =
        this.attributes.findIndex((x) => x.reference === 'TAMANO') >= 0;

      const hasTAMANO_DIAM =
        this.attributes.findIndex((x) => x.reference === 'TAMANO_DIAM') >= 0;

      let currentTAMANO = null;

      if (isMantel) {
        currentTAMANO = this.attributes.find((x) => x.reference === 'CAIDA')
          .selector_inputs;
        const currentCaida = currentTAMANO.value.fall;

        return currentCaida;
      } else if (hasTAMANO) {
        currentTAMANO = this.attributes.find((x) => x.reference === 'TAMANO')
          .selector_inputs;

        const currentWidth = currentTAMANO.value.width;
        const currentLength = currentTAMANO.value.length;

        const desiredRatio = currentWidth / currentLength;

        return desiredRatio;
      } else if (hasTAMANO_DIAM) {
        currentTAMANO = this.attributes.find(
          (x) => x.reference === 'TAMANO_DIAM'
        ).selector_inputs;

        const currentDiameter = currentTAMANO.value.diameter;

        return currentDiameter;
      }
    },

    updatePrice() {
      actions
        .postProductQuotePrice(this.productID, {
          attributes: this.attributes,
          quantity: this.quantity,
        })
        .then((x) => {
          this.currentPrice = x.data.price;
        });
    },

    allAttributesFilledIn() {
      const numAttributesFilledIn = this.attributes.filter(
        (yyy) =>
          'selector_inputs' in yyy &&
          yyy.selector_inputs &&
          yyy.selector_inputs.value
      ).length;

      return numAttributesFilledIn === this.attributes.length;
    },
    evaluateUpdatePriceAndCanvas() {
      //if (this.productData.is_price_variable) {
      if (
        this.allAttributesFilledIn() &&
        (this.canvasInitialized || this.productData.type === 'offline')
      ) {
        // this.canvasError = false;
        // if (this.canvasError === true) {
        //   // need to re-render in DOM
        //   this.render();
        // }
        this.updatePrice();
        this.renderCanvas();
      }
    },

    async setExtraInfoAttributes(attributes) {
      return new Promise(async (resolve, reject) => {
        let colorOptions = [];

        // If BORDADO or INICIALES, get all colors of catalogue
        if (
          attributes.findIndex((y) =>
            ['BORDADO', 'INICIALES'].includes(y.reference)
          ) >= 0
        ) {
          const tmp = await actions.getColorsUnpaginated();

          colorOptions = tmp.data.results.map((yy) => {
            return {
              text: yy.reference,
              value: yy.id,
            };
          });
        }

        // Extra info for BORDADO and INICIALES
        for (let index = 0; index < attributes.length; index++) {
          const element = attributes[index];
          const attributeType = element.reference;

          if (attributeType === 'BORDADO') {
            attributes[index]['extra_info'] = {
              color_options: colorOptions,
              embroideries_sizes: this.productData.embroideries_sizes,
            };
          }

          if (attributeType === 'TELA') {
            const tmpTela = await actions.getFabricsUnpaginated();

            attributes[index]['extra_info'] = {
              fabricsInfo: tmpTela.data.results,
            };
          }

          if (attributeType === 'INICIALES') {
            attributes[index]['extra_info'] = {
              color_options: colorOptions,
              initials_sizes: this.productData.initials_sizes,
            };
          }
        }

        resolve(attributes);
      });
    },

    inputChanged(type, attributeIndex, value) {
      if (type === 'INPUT') {
        this.$set(this.attributes[attributeIndex], 'selector_inputs', {
          value: value.value,
          txtValue: value.value,
          name: value.value,
        });
      }

      //debugger;

      this.evaluateUpdatePriceAndCanvas();
    },

    optionSelected(type, attributeIndex, value) {
      if (type === 'TAMANO') {
        this.$set(this.attributes[attributeIndex], 'selector_inputs', {
          value: value.value,
          name: value.value.width + 'x' + value.value.length,
        });

        // Update SVGs if ratio changes
        const desiredRatio = this.calculateSelectedRatio();
        const wouldBeRatio = this.getCloserNumber(this.ratios, desiredRatio);
        if (this.currentRatio !== wouldBeRatio) {
          this.currentRatio = wouldBeRatio;
          this.reLoadSVGs();
        }
      }

      if (type === 'TAMANO_DIAM') {
        this.$set(this.attributes[attributeIndex], 'selector_inputs', {
          value: value.value,
          name: value.value.diameter,
        });

        // Update SVGs if ratio changes
        const desiredRatio = this.calculateSelectedRatio();
        const wouldBeRatio = this.getCloserNumber(this.ratios, desiredRatio);
        if (this.currentRatio !== wouldBeRatio) {
          this.currentRatio = wouldBeRatio;
          this.reLoadSVGs();
        }
      }

      if (type === 'CAIDA') {
        this.$set(this.attributes[attributeIndex], 'selector_inputs', {
          value: value.value,
          name: value.value.fall,
        });

        // Update SVGs if ratio changes
        const desiredRatio = this.calculateSelectedRatio();
        const wouldBeRatio = this.getCloserNumber(this.ratios, desiredRatio);
        if (this.currentRatio !== wouldBeRatio) {
          this.currentRatio = wouldBeRatio;
          this.reLoadSVGs();
        }
      }

      if (type === 'TAMANO_LIBRE') {
        this.$set(this.attributes[attributeIndex], 'selector_inputs', {
          value: value.value,
          name: value.value.width + 'x' + value.value.length,
        });
      }

      if (type === 'TAMANO_LIBRE_CAMA') {
        this.$set(this.attributes[attributeIndex], 'selector_inputs', {
          value: value.value,
          name:
            value.value.width +
            'x' +
            value.value.length +
            'x' +
            value.value.height,
        });
      }

      if (type === 'TELA') {
        this.$set(this.attributes[attributeIndex], 'selector_inputs', {
          value: value.value,
          name: value.name,
        });
      }

      if (type === 'TIRA_BORDADA') {
        this.$set(this.attributes[attributeIndex], 'selector_inputs', {
          value: value.value,
          name: value.name,
        });
      }

      if (type === 'TIRA_BORDADA_CON_ENTREDOS') {
        this.$set(this.attributes[attributeIndex], 'selector_inputs', {
          value: value.value,
          name: value.name,
        });
      }

      if (type === 'HILO') {
        this.$set(this.attributes[attributeIndex], 'selector_inputs', {
          value: value.value,
          name: value.name,
        });
      }

      if (type === 'BORDADO') {
        this.$set(this.attributes[attributeIndex], 'selector_inputs', {
          value: value.value,
          name: value.name,
        });
      }

      if (type === 'INICIALES') {
        this.$set(this.attributes[attributeIndex], 'selector_inputs', {
          value: value.value,
          name: value.name,
        });
      }

      if (type === 'PUNTADA') {
        this.$set(this.attributes[attributeIndex], 'selector_inputs', {
          value: value.value,
          name: value.name,
        });
      }

      this.evaluateUpdatePriceAndCanvas();

      // if (type === 'HILO_PUNTADA') {
      //   this.$set(this.attributes[attributeIndex], 'selector_inputs', {
      //     element_id: value.value,
      //     name: value.name,
      //   });
      // }

      // If all the fields are filled out, quote price
    },

    removeCurrentText(viewCanvas) {
      let that = this;
      // let objectsRegexStitchTop = new RegExp('stitchTop*');
      // let objectsRegexStitchLeft = new RegExp('stitchLeft*');

      that.canvas[viewCanvas].getObjects('text').map((y) => {
        that.canvas[viewCanvas].remove(y);
      });
      that.canvas[viewCanvas].renderAll();
    },

    removeCurrentStitches(viewCanvas) {
      let that = this;
      // let objectsRegexStitchTop = new RegExp('stitchTop*');
      // let objectsRegexStitchLeft = new RegExp('stitchLeft*');

      that.canvas[viewCanvas].getObjects('rect').map((y) => {
        const elementType = y['myType'];
        if (elementType && elementType === 'stitch') {
          that.canvas[viewCanvas].remove(y);
        }
      });
      // that.canvas[viewCanvas].renderAll();
    },

    getColorInfo(color) {
      let promiseColor = new Promise((resolve, reject) => {
        actions.getColor(color).then((x) => {
          resolve(x.data);
        });
      });
      return Promise.all([promiseColor]);
    },
    getColor(color) {
      let promiseColor = new Promise((resolve, reject) => {
        actions.getColor(color).then((x) => {
          resolve(x.data.code_hex);
        });
      });
      return Promise.all([promiseColor]);
    },

    getStitchImageAndColor(val, color) {
      let that = this;
      let promiseImage = new Promise((resolve, reject) => {
        actions.getStitch(val).then((x) => {
          fabric.loadSVGFromURL(x.data.image, function (objects, options) {
            // Stitches are only 1 object, pushing another one so that groupSVGElements creates a group (and then the padding is respected)
            // See https://github.com/fabricjs/fabric.js/issues/6147

            // objects.push(new fabric.Object());

            let loadedObject = fabric.util.groupSVGElements(objects, options);

            // loadedObject['myType'] = 'stitch';

            resolve({
              fabricObj: loadedObject,
              heightCM: x.data.height,
              sizes: x.data.sizes,
              route_type: x.data.route_type,
            });
          });
        });
      });
      let promiseColor = new Promise((resolve, reject) => {
        actions.getColor(color).then((x) => {
          resolve(x.data.code_hex);
        });
      });
      return Promise.all([promiseImage, promiseColor]);
    },

    getStitchInfo(val) {
      return new Promise((resolve, reject) => {
        actions.getStitch(val).then((x) => {
          resolve(x.data);
        });
      });
    },

    getFabricInfo(val) {
      return new Promise((resolve, reject) => {
        actions.getFabric(val).then((x) => {
          resolve(x.data);
        });
      });
    },

    getValueForAttributeType(type) {
      return this.attributes.find((x) => x.reference === type);
    },

    getValueForAttributeTypeAndName(type, name) {
      return this.attributes.find(
        (x) => x.reference === type && x.label === name
      );
    },

    initCanvas() {
      // if (reset) {
      //   for (let index = 0; index < this.canvas.length; index++) {
      //     const element = this.canvas[index];
      //     element.clear();
      //   }
      //   this.canvas = [];
      // }

      if (this.productData === null) {
        return;
      }

      const isMantel = [
        'MANTEL_MUST',
        'MANTEL_ABSOLUTE',
        'MANTEL_DOBLE_BOR',
        'MANTEL_BOR',
        'MANTEL_ONDAS',
        'MANTEL_FLECOS_APL',
        'MANTEL_FLECOS',
      ].includes(this.productData.template);

      if (isMantel) {
        this.three.initialized = true;

        if (this.$refs['viewsDesktop3D'] === undefined) {
          return;
        }
        // Init Threejs WebGL

        const w = this.$refs['viewsDesktop3D'].clientWidth;
        const h = this.$refs['viewsDesktop3D'].clientHeight;

        this.three.camera = new THREE.PerspectiveCamera(45, w / h, 0.01, 100);

        this.three.scene = new THREE.Scene();

        this.three.scene.add(this.three.camera);

        const axesHelper = new THREE.AxesHelper(5);

        this.three.scene.add(axesHelper);

        this.three.renderer = new THREE.WebGLRenderer({
          antialias: true,
          alpha: true,
          preserveDrawingBuffer: true,
        });

        this.three.renderer.setSize(w, h);
        // this.three.renderer.setPixelRatio(window.devicePixelRatio);

        this.$refs['viewsDesktop3D'].appendChild(
          this.three.renderer.domElement
        );

        this.three.renderer.render(this.three.scene, this.three.camera);

        let that = this;

        function animate() {
          that.three.renderer.render(that.three.scene, that.three.camera);
        }
        that.three.renderer.setAnimationLoop(animate);

        this.three.renderer.setAnimationLoop(animate);

        // let controls = new OrbitControls(
        //   this.three.camera,
        //   this.three.renderer.domElement
        // );
        // controls.listenToKeyEvents(this.$refs['viewsDesktop3D']); // optional
        // controls.update();

        // controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled

        // controls.screenSpacePanning = false;

        // controls.minDistance = 0;
        // controls.maxDistance = 10;

        // controls.maxPolarAngle = Math.PI / 2;

        // controls.update();

        this.canvasInitialized = true;
        this.evaluateUpdatePriceAndCanvas();
      } else {
        this.views.map((v, i) => {
          if (this.minWidth === 0) {
            let width = document.getElementsByClassName('tab-' + i)[0]
              .clientWidth;
            let height = document.getElementsByClassName('tab-' + i)[0]
              .clientHeight;

            this.minWidth = Math.min(width, height);
          }

          this.canvas.push(
            new fabric.StaticCanvas(this.$refs['canvas-' + i][0], {
              width: this.minWidth,
              height: this.minWidth,
              enableRetinaScaling: false,
            })
          );
        });
        this.canvasInitialized = true;
        this.evaluateUpdatePriceAndCanvas();
      }
    },

    renderInicialesEspecialFlecos() {
      const isFlecos = [
        'SERV_MESA_FLECOS',
        'SERV_MERI_FLECOS',
        'SERV_COCKT_FLECOS',
        'SERV_MESA_FLEC_APL',
      ].includes(this.productData.template);
      if (isFlecos) {
        let viewsByID = {};

        for (let index = 0; index < this.canvas.length; index++) {
          const viewProperties = this.views[index];
          viewsByID[viewProperties.id] = index;
        }

        let attrIniciales = this.attributes.find(
          (x) => x.reference === 'INICIALES'
        );
        // this.renderINICIALES(attrIniciales, viewsByID);

        let that = this;
        let selectorValue = attrIniciales.selector_inputs.value;

        let enabled = selectorValue.enabled;
        let color = selectorValue.color;
        let size = selectorValue.size;
        let text = selectorValue.text;
        let typography = selectorValue.typography;
        let typography_visual = selectorValue.renderer.typography_visual;
        let size_cm = selectorValue.renderer.size_cm;

        if (
          enabled &&
          color !== null &&
          size !== '' &&
          text !== '' &&
          typography !== ''
        ) {
          for (let index = 0; index < attrIniciales.targets.length; index++) {
            const target = attrIniciales.targets[index];

            let viewCanvas = viewsByID[target.view];

            that.removeCurrentText(viewCanvas);

            let textRegex = new RegExp('text*');

            let scaleXMarco = 1;

            let multiplier = 1;
            const scaleYMarco = 1;

            let x = 340;
            let y = 400;

            if (this.productData.template === 'SERV_MERI_FLECOS') {
              scaleXMarco = 0.92;
              multiplier = 1.3;

              const pxText = fabric.util.parseUnit(size_cm + 'cm') * multiplier;
              y = 390 - pxText / 2;
            }

            if (this.productData.template === 'SERV_COCKT_FLECOS') {
              multiplier = 1.1;
              const pxText = fabric.util.parseUnit(size_cm + 'cm') * multiplier;
              y = 460 - pxText / 2;
            }

            if (this.productData.template === 'SERV_MESA_FLECOS') {
              multiplier = 0.65;
              const pxText = fabric.util.parseUnit(size_cm + 'cm') * multiplier;
              y = 468 - pxText / 2;
            }

            if (this.productData.template === 'SERV_MESA_FLEC_APL') {
              multiplier = 0.65;
              const pxText = fabric.util.parseUnit(size_cm + 'cm') * multiplier;
              y = 468 - pxText / 2;
            }

            this.getColor(color).then((loadedObject) => {
              let fabricText = new fabric.Text(text, {
                fontFamily: typography_visual,
                textAlign: 'center',
                originX: 'center',
                originY: 'center',
                left: x,
                top: y,
                fill: '#' + loadedObject[0],
                fontSize:
                  fabric.util.parseUnit(size_cm + 'cm') *
                  scaleXMarco *
                  multiplier,
                // this.aspectRatio.width,
              });

              that.canvas[viewCanvas].add(fabricText);
              that.canvas[viewCanvas].bringToFront(fabricText);
            });
            that.canvas[viewCanvas].renderAll();
          }
        } else {
          for (let index = 0; index < attrIniciales.targets.length; index++) {
            const target = attrIniciales.targets[index];

            let viewCanvas = viewsByID[target.view];

            that.removeCurrentText(viewCanvas);
          }
        }
      }
    },

    renderINICIALES(attr, viewsByID) {
      let that = this;
      let selectorValue = attr.selector_inputs.value;

      let enabled = selectorValue.enabled;
      let color = selectorValue.color;
      let size = selectorValue.size;
      let text = selectorValue.text;
      let typography = selectorValue.typography;
      let typography_visual = selectorValue.renderer.typography_visual;
      let size_cm = selectorValue.renderer.size_cm;

      if (
        enabled &&
        color !== null &&
        size !== '' &&
        text !== '' &&
        typography !== ''
      ) {
        for (let index = 0; index < attr.targets.length; index++) {
          const target = attr.targets[index];
          let viewCanvas = viewsByID[target.view];

          that.removeCurrentText(viewCanvas);

          let textRegex = new RegExp('text*');

          that.canvas[viewCanvas].getObjects('group').map((allObjects) => {
            allObjects.getObjects().map((element) => {
              let elementID = element.id || '';

              if (elementID && elementID.match(textRegex)) {
                const scaleXMarco = element.group.scaleX;
                const scaleYMarco = element.group.scaleY;

                const x =
                  (element.left + element.group.width / 2) * scaleXMarco;
                let y = (element.top + element.group.height / 2) * scaleYMarco;

                let multiplier = 1;

                if (that.productData.template == 'SERV_MERI_MUST') {
                  multiplier = 1.95;
                  const pxText =
                    fabric.util.parseUnit(size_cm + 'cm') * multiplier;
                  y = y - pxText / 2;
                }

                if (that.productData.template == 'SERV_MERI_OND') {
                  multiplier = 1.95;
                }

                if (that.productData.template == 'SERV_MERI_BOR') {
                  multiplier = 2.25;
                }

                if (that.productData.template == 'SERV_MESA_MUST') {
                  const pxText =
                    fabric.util.parseUnit(size_cm + 'cm') * multiplier;
                  y = y - pxText / 2;
                }

                if (that.productData.template == 'SERV_COCKT_MUST') {
                  multiplier = 1.35;

                  const pxText =
                    fabric.util.parseUnit(size_cm + 'cm') * multiplier;
                  y = y - pxText / 2;
                }

                if (that.productData.template == 'SERV_COCKT_BOR') {
                  multiplier = 1.35;
                }

                this.getColor(color).then((loadedObject) => {
                  let fabricText = new fabric.Text(text, {
                    fontFamily: typography_visual,
                    textAlign: 'center',
                    originX: 'center',
                    originY: 'center',
                    left: x,
                    top: y,
                    fill: '#' + loadedObject[0],
                    fontSize:
                      fabric.util.parseUnit(size_cm + 'cm') *
                      scaleXMarco *
                      multiplier,

                    // this.aspectRatio.width,
                  });

                  that.canvas[viewCanvas].add(fabricText);
                  that.canvas[viewCanvas].bringToFront(fabricText);
                });
              }
            });
          });
          that.canvas[viewCanvas].renderAll();
        }
      } else {
        if (attr.targets !== undefined) {
          for (let index = 0; index < attr.targets.length; index++) {
            const target = attr.targets[index];
            let viewCanvas = viewsByID[target.view];

            that.removeCurrentText(viewCanvas);
          }
        }
      }
    },

    renderTELA(attr, viewsByID) {
      let that = this;
      let selectorValue = attr.selector_inputs.value;

      let attrTAMANO = null;

      const hasTAMANO =
        this.attributes.findIndex((x) => x.reference === 'TAMANO') >= 0;

      const hasTAMANO_DIAM =
        this.attributes.findIndex((x) => x.reference === 'TAMANO_DIAM') >= 0;

      let widthSelectedCM = 0;
      let longSelectedCM = 0;

      if (hasTAMANO) {
        attrTAMANO = this.getValueForAttributeTypeAndName(
          'TAMANO',
          'Escoge tu tamaño'
        );

        widthSelectedCM = parseInt(attrTAMANO.selector_inputs.value.width); // 35cm
        longSelectedCM = parseInt(attrTAMANO.selector_inputs.value.length); // 45cm
      } else if (hasTAMANO_DIAM) {
        attrTAMANO = this.getValueForAttributeTypeAndName(
          'TAMANO_DIAM',
          'Escoge tu tamaño'
        );

        widthSelectedCM = parseInt(attrTAMANO.selector_inputs.value.diameter); // 35cm
        longSelectedCM = parseInt(attrTAMANO.selector_inputs.value.diameter); // 45cm
      }

      if (this.aspectRatio !== null) {
        // Servilletas use case: they are partially shown in the simulator (folded napkin)
        // in that case, widthSelectedCM,longSelectedCM will be adjusted based on aspectRatio
        widthSelectedCM *= this.aspectRatio.width; // 35cm
        longSelectedCM *= this.aspectRatio.long; // 45cm
      }

      // return new Promise((resolve, reject) => {
      this.getFabricInfo(selectorValue).then((data) => {
        let constImageURI = data.image;

        const widthBase = data.base_width; // ancho
        const heightBase = data.base_length; // largo

        const icon_coords_x = data.icon_coords_x;
        const icon_coords_y = data.icon_coords_y;
        const icon_coords_w = data.icon_coords_w;
        const icon_coords_h = icon_coords_w / 1.5;
        const desiredCenterX = icon_coords_x + icon_coords_w / 2;
        const desiredCenterY = icon_coords_y + icon_coords_h / 2;

        fabric.Image.fromURL(
          constImageURI,
          function (img) {
            const widthImage = img.width;
            const heightImage = img.height;

            const isPrinted = data.design.length > 0 && data.design[0] === 7;

            const cropWidth = Math.floor(
              (widthSelectedCM * heightImage) / widthBase
            );

            const cropLong = Math.floor(
              (longSelectedCM * widthImage) / heightBase
            );

            let cropFinal = Math.max(cropWidth, cropLong);

            for (let index = 0; index < attr.targets.length; index++) {
              const target = attr.targets[index];
              let viewCanvas = viewsByID[target.view];
              let objectsRegex = new RegExp(target.id);

              that.canvas[viewCanvas].getObjects().map((allObjects) => {
                if (allObjects.type === 'group') {
                  allObjects.getObjects().map((element) => {
                    let elementID = element.id || '';

                    if (elementID.match(objectsRegex)) {
                      /* Centering, for printed fabrics */

                      const isCamino = [
                        'CAM_MES_FLEC',
                        'CAM_MES_FLEC_APL',
                        'CAM_MES_MUST',
                      ].includes(that.productData.template); // diagonal fabrics

                      if (isCamino) {
                        const widthImage2 = img.width; // 1000
                        const heightImage2 = img.height; // 896

                        img.set({
                          centeredRotation: true,
                        });

                        // Cropping

                        const cropWidth = Math.floor(
                          (widthSelectedCM * widthImage2) / widthBase
                        );

                        const cropLong = Math.floor(
                          (longSelectedCM * heightImage2) / heightBase
                        );

                        let cropFinal = Math.max(cropWidth, cropLong); // 2600

                        const sX2 =
                          (1 / allObjects.scaleX) * (that.minWidth / cropFinal);

                        const sY2 =
                          (1 / allObjects.scaleY) * (that.minWidth / cropFinal);

                        img.set({
                          scaleX: sX2,
                          scaleY: sY2,
                        });

                        let imageSpace;

                        // Rotation
                        if (widthImage2 > heightImage2) {
                          img.rotate(90);
                          imageSpace =
                            (widthImage2 * img.scaleX -
                              heightImage2 * img.scaleY) /
                            2;

                          img.top += imageSpace;
                          img.left -= imageSpace;
                        } else {
                          img.rotate(90);
                          imageSpace =
                            (heightImage2 * img.scaleY -
                              widthImage2 * img.scaleX) /
                            2;

                          img.left += imageSpace;
                          img.top -= imageSpace;
                        }

                        let patternSourceCanvas = new fabric.StaticCanvas(
                          null,
                          {
                            enableRetinaScaling: false,
                          }
                        );
                        patternSourceCanvas.add(img);

                        patternSourceCanvas.setDimensions({
                          width: heightImage2 * img.scaleY,
                          height: widthImage2 * img.scaleX,
                        });

                        patternSourceCanvas.renderAll();

                        const patternImageCentered = new fabric.Pattern({
                          source: patternSourceCanvas.getElement(),
                          repeat: 'repeat',
                          offsetX: 0,
                          offsetY: 0,
                        });

                        element.set('fill', patternImageCentered);
                      } else {
                        const expectedCenterX = cropLong / 2;
                        const expectedCenterY = cropWidth / 2;

                        const leftAdjustment = desiredCenterX - expectedCenterX;

                        const topAdjustment = desiredCenterY - expectedCenterY;

                        const sX =
                          (1 / allObjects.scaleX) * (that.minWidth / cropFinal);
                        const sY =
                          (1 / allObjects.scaleY) * (that.minWidth / cropFinal);

                        let offsetX = -leftAdjustment * sX;
                        let offsetY = -topAdjustment * sY;

                        const isIndividual = that.productData.template.startsWith(
                          'IND_'
                        );

                        if (element.id === 'centro1' && isIndividual) {
                          // for IND_ABS only. There is a marco of 5cm
                          // TODO: make this dynamic!! via product template definition?
                          offsetX -= fabric.util.parseUnit('5cm');
                          offsetY -= fabric.util.parseUnit('5cm');
                        }

                        img.set({
                          scaleX: sX,
                          scaleY: sY,
                        });

                        let patternSourceCanvas = new fabric.StaticCanvas(
                          null,
                          {
                            enableRetinaScaling: false,
                          }
                        );
                        patternSourceCanvas.add(img);

                        patternSourceCanvas.setDimensions({
                          width: img.width * sX,
                          height: img.height * sY,
                        });
                        patternSourceCanvas.renderAll();

                        const isServilletaMerienda = [
                          'SERV_MERI_BOR',
                          'SERV_MERI_MUST',
                          'SERV_MERI_OND',
                          'SERV_MERI_FLECOS',
                        ].includes(that.productData.template);

                        if (isServilletaMerienda) {
                          const pattern = new fabric.Pattern({
                            source: patternSourceCanvas.getElement(),
                            repeat: 'repeat',
                          });

                          const rect = new fabric.Rect({
                            left: 400,
                            top: 100,
                            width: img.width * 2,
                            height: img.height * 2,
                            fill: pattern,
                            originX: 'center',
                            originY: 'center',
                            objectCaching: false,
                          });

                          // that.canvas[viewCanvas].add(rect);

                          let patternSourceCanvas2 = new fabric.StaticCanvas(
                            null,
                            {
                              enableRetinaScaling: false,
                            }
                          );
                          patternSourceCanvas2.setDimensions({
                            width: rect.width,
                            height: rect.height,
                          });
                          patternSourceCanvas2.add(rect);
                          rect.rotate(-45);
                          patternSourceCanvas2.renderAll();

                          const pattern2 = new fabric.Pattern({
                            source: patternSourceCanvas2.getElement(),
                            repeat: 'no-repeat',
                          });

                          element.set('fill', pattern2);
                        } else {
                          const patternImageCentered = new fabric.Pattern({
                            source: patternSourceCanvas.getElement(),
                            repeat: 'repeat',
                            offsetX: offsetX,
                            offsetY: offsetY,
                          });

                          element.set('fill', patternImageCentered);
                        }
                      }
                    }
                  });
                }
                that.canvas[viewCanvas].renderAll();
              });
            }
          },
          { crossOrigin: 'Anonymous' }
        );
        // });
      });
    },

    renderCanvas() {
      const isMantel = [
        'MANTEL_MUST',
        'MANTEL_ABSOLUTE',
        'MANTEL_DOBLE_BOR',
        'MANTEL_BOR',
        'MANTEL_ONDAS',
        'MANTEL_FLECOS_APL',
        'MANTEL_FLECOS',
      ].includes(this.productData.template);

      if (isMantel) {
        this.loadSVGsEspecialMantel();
        return;
      }

      const isFlecosMixed = [
        'IND_FLECOS_APLICADO',
        'IND_FLECO_RED',
        'IND_FLECO_APL_RED',
        'IND_FLECOS',
        'SERV_MESA_FLECOS',
        'SERV_MERI_FLECOS',
        'SERV_MESA_FLEC_APL',
        'SERV_COCKT_FLECOS',
        'CAM_MES_FLEC',
        'CAM_MES_FLEC_APL',
        'CAM_MES_MUST',
      ].includes(this.productData.template);

      const isFlecosMixedWithInitials = [
        'SERV_MESA_FLECOS',
        'SERV_MERI_FLECOS',
        'SERV_MESA_FLEC_APL',
        'SERV_COCKT_FLECOS',
      ].includes(this.productData.template);

      if (isFlecosMixed) {
        this.loadSVGsEspecialFlecosMixed();
        if (isFlecosMixedWithInitials) {
          this.renderInicialesEspecialFlecos();
        }
      }

      let viewsByID = {};
      let that = this;

      for (let index = 0; index < this.canvas.length; index++) {
        const viewProperties = this.views[index];
        viewsByID[viewProperties.id] = index;
      }

      for (let index = 0; index < this.attributes.length; index++) {
        const attr = this.attributes[index];

        if (attr.reference === 'INICIALES') {
          if (!isFlecosMixedWithInitials) {
            this.renderINICIALES(attr, viewsByID);
          }
        } else if (
          attr.reference === 'TELA' &&
          attr.targets &&
          attr.targets.length > 0
        ) {
          let selectorValue = attr.selector_inputs.value;

          this.renderTELA(attr, viewsByID);
        } else if (
          attr.reference === 'PUNTADA' &&
          attr.targets &&
          attr.targets.length > 0
        ) {
          let colorSelectorIndex = this.attributes.findIndex(
            (x) => x.reference === 'HILO'
          );

          let color = this.attributes[colorSelectorIndex].selector_inputs.value;

          let selectorValue = attr.selector_inputs.value;

          this.getStitchImageAndColor(selectorValue, color).then(
            (loadedObject) => {
              for (let index = 0; index < attr.targets.length; index++) {
                const target = attr.targets[index];
                let viewCanvas = viewsByID[target.view];

                this.removeCurrentStitches(viewCanvas);

                let objectsRegexStitchTop = new RegExp('stitchTop*');
                let objectsRegexStitchLeft = new RegExp('stitchLeft*');
                let objectsRegexStitchRight = new RegExp('stitchRight*');
                let objectsRegexStitchBottom = new RegExp('stitchBottom*');

                let objectsRegexStitchRotatedLB = new RegExp(
                  'stitchRotatedLB*'
                );
                let objectsRegexStitchRotatedRB = new RegExp(
                  'stitchRotatedRB*'
                );

                this.canvas[viewCanvas]
                  .getObjects('group')
                  .map((allObjects) => {
                    allObjects.getObjects().map((element) => {
                      let elementID = element.id || '';

                      if (elementID && elementID.match(objectsRegexStitchTop)) {
                        let rectTop = this.setupStitchTop(
                          element,
                          loadedObject,
                          viewCanvas
                        );

                        that.canvas[viewCanvas].add(rectTop);
                        that.canvas[viewCanvas].renderAll();
                      }
                      if (
                        elementID &&
                        elementID.match(objectsRegexStitchLeft)
                      ) {
                        let rectLeft = this.setupStitchLeft(
                          element,
                          loadedObject
                        );
                        that.canvas[viewCanvas].add(rectLeft);
                        that.canvas[viewCanvas].renderAll();
                      }

                      if (
                        elementID &&
                        elementID.match(objectsRegexStitchRight)
                      ) {
                        let rectRight = this.setupStitchRight(
                          element,
                          loadedObject,
                          viewCanvas
                        );

                        that.canvas[viewCanvas].add(rectRight);
                        that.canvas[viewCanvas].renderAll();
                      }
                      if (
                        elementID &&
                        elementID.match(objectsRegexStitchBottom)
                      ) {
                        let rectBottom = this.setupStitchBottom(
                          element,
                          loadedObject,
                          viewCanvas
                        );

                        that.canvas[viewCanvas].add(rectBottom);
                        that.canvas[viewCanvas].renderAll();
                      }

                      if (
                        elementID &&
                        elementID.match(objectsRegexStitchRotatedLB)
                      ) {
                        let rectTop = this.setupStitchRotatedLB(
                          element,
                          loadedObject,
                          viewCanvas
                        );

                        that.canvas[viewCanvas].add(rectTop);

                        that.canvas[viewCanvas]
                          .getObjects()
                          .map((allObjects) => {
                            if (allObjects.type === 'group') {
                              allObjects.getObjects().map((element) => {
                                let elementID = element.id || '';
                                if (elementID.startsWith('ocultador')) {
                                  // element.moveTo(9);
                                  that.canvas[viewCanvas].bringToFront(element);
                                }
                              });
                            }
                          });

                        that.canvas[viewCanvas].renderAll();
                      }

                      if (
                        elementID &&
                        elementID.match(objectsRegexStitchRotatedRB)
                      ) {
                        let rectTop = this.setupStitchRotatedRB(
                          element,
                          loadedObject,
                          viewCanvas
                        );
                        that.canvas[viewCanvas].add(rectTop);

                        that.canvas[viewCanvas]
                          .getObjects()
                          .map((allObjects) => {
                            if (allObjects.type === 'group') {
                              allObjects.getObjects().map((element) => {
                                let elementID = element.id || '';
                                if (elementID.startsWith('ocultador')) {
                                  // element.moveTo(9);
                                  that.canvas[viewCanvas].bringToFront(element);
                                }
                              });
                            }
                          });
                        that.canvas[viewCanvas].renderAll();
                      }
                    });
                  });

                // that.canvas[viewCanvas].renderAll();
              }
            }
          );
        } else if (
          attr.reference === 'HILO' &&
          'targets' in attr &&
          attr.targets.length > 0
        ) {
          // Bordón and Ondas
          let colorSelectorIndex = this.attributes.findIndex(
            (x) => x.reference === 'HILO'
          );

          let color = this.attributes[colorSelectorIndex].selector_inputs.value;

          this.getColor(color).then((loadedObject) => {
            for (let index = 0; index < attr.targets.length; index++) {
              const target = attr.targets[index];
              let viewCanvas = viewsByID[target.view];
              let objectsRegex = new RegExp(target.id);
              //debugger;

              that.canvas[viewCanvas].getObjects().map((allObjects) => {
                if (allObjects.type === 'group') {
                  allObjects.getObjects().map((element) => {
                    let elementID = element.id || '';
                    if (elementID.match(objectsRegex)) {
                      element.set({ fill: '#' + loadedObject[0] });
                    }
                  });
                }
              });
              that.canvas[viewCanvas].renderAll();
            }
          });
        }
      }
    },

    reLoadSVGs() {
      if (this.canvas.length > 0) {
        // initialized
        this.views.map((v, i) => {
          this.canvas[i].clear();
        });
        this.loadSVGs();
      }
    },

    loadSVGs() {
      let that = this;

      if (
        this.currentRatio === null &&
        this.allAttributesFilledIn() &&
        this.canvasInitialized
      ) {
        const desiredRatio = this.calculateSelectedRatio();
        this.currentRatio = this.getCloserNumber(this.ratios, desiredRatio);
      }

      const isMantel = [
        'MANTEL_MUST',
        'MANTEL_ABSOLUTE',
        'MANTEL_DOBLE_BOR',
        'MANTEL_BOR',
        'MANTEL_ONDAS',
        'MANTEL_FLECOS_APL',
        'MANTEL_FLECOS',
      ].includes(this.productData.template);

      if (isMantel) {
        return;
      }

      this.views.map((v, i) => {
        v.layers.map((layer) => {
          fabric.loadSVGFromURL(
            process.env.VUE_APP_API_BASE_URL.replace('api/', '') +
              'uploads/product_templates/' +
              this.productData.template +
              '/' +
              this.currentRatio +
              '/' +
              layer.file,
            function (objects, options) {
              let loadedObject = fabric.util.groupSVGElements(objects, options);

              loadedObject.scaleToWidth(that.canvas[i].getWidth());

              // AVOID CENTERING 2D ELEMENTS TO DECREASE SPACE BTW RENDER AND TRANSPARENT FABRICS WARNING
              // loadedObject.top =
              //   (that.canvas[i].getHeight() -
              //     loadedObject.top -
              //     loadedObject.height * loadedObject.scaleY) /
              //   2;
              // loadedObject.setCoords();

              that.canvas[i].add(loadedObject);
            }
          );
        });
      });
    },

    render() {
      this.$nextTick(() => {
        this.initCanvas();
        this.loadSVGs();
      });
    },

    checkCustomizerErrors() {
      let anyErrors = false;
      for (let index = 0; index < this.attributes.length; index++) {
        const ref = this.$refs['customizer-' + index][0];

        ref.$v.form.$touch();
        if (ref.$v.$anyError) {
          anyErrors = true;
        }
      }
      return anyErrors;
    },

    modalHidden() {
      this.$emit('hidden');
    },
  },
  mounted() {},
  updated() {
    //this.renderViews();
  },
};
</script>

<style lang="scss" scoped>
#viewsDesktop3D {
  width: 100%;
  height: 350px;

  canvas {
    width: 100%;
    height: 100%;
  }
}

#viewsDesktop {
  .canvas {
    width: 100%;
    padding-right: 1rem;
    height: 350px;
  }
  .col {
    &:last-child {
      .canvas {
        padding-right: 0;
      }
    }
  }
}
</style>
